import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import HistoryPopUp from "./history_popup.js";
import withReactContent from "sweetalert2-react-content";
import "../styles/task_popup.css";
import AddTask from "./add_task.js";
import NotePopUp from "./note_popup.js";
import AdditionalWezw from "./additionalWezw.js";
import AdditionalPozw from "./additionalPozw.js";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";
import AddClientConn from "./addClientConn.js";
import ClientPopUp from "./client_popup.js";
import EditPelnSub from "./editPelnSub.js";
import AddFile from "./add_file.js";
import SendPostTask from "./sendPostTask.js";
import { faEdit, faEye, faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CheckPackage from "./checkPackage.js";
import LawsuitCheckList from "./lawsuitCheckList.js";
import { isNumber } from "lodash";
import LawsuitCheckListView from "./lawsuitCheckListView";

const MySwal = withReactContent(Swal2);

const TaskPopUp = (props) => {
  const [tasksForClient, setTasksForClient] = useState([]);
  const [showEditPelnSub, setShowEditPelnSub] = useState(false);
  const [taskData, setTaskData] = useState("");
  const [filesData, setFilesData] = useState([]);
  const [fillResponsible, setFillResponsible] = useState(false);
  const [responsible, setResponsible] = useState("");
  const [openHistory, setOpenHistory] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [notePopUp, setNotePopUp] = useState(false);
  const [showAdditionalWezw, setShowAdditionalWezw] = useState(false);
  const [showAdditionalPozw, Mozambik15] = useState(false);
  const [loading, setLoading] = useState(true);
  const [client, setClient] = useState([]);
  const [showAddClientConn, setShowAddClientConn] = useState(false);
  const [showClientReport, setShowClientReport] = useState(false);
  const [clientsReportValue, setClientsReportValue] = useState(false);
  const [clients, setClients] = useState([]);
  const [showAddFile, setShowAddFile] = useState(false);
  const [holidays, setHolidays] = useState([]);
  const [userSend, setUserSend] = useState([]);
  const [userSend2, setUserSend2] = useState([]);
  const [userSend4, setUserSend4] = useState([]);
  const [freeDays, setFreeDays] = useState([]);
  const [showSendPost, setShowSendPost] = useState(false);
  const [showSendPostButton, setShowSendPostButton] = useState(false);
  const [bufPost, setBufPost] = useState([]);
  const [postData, setPostData] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showChecklist, setShowChecklist] = useState(false);
  const [numNad, setNumNad] = useState("");
  const [guid, setGuid] = useState("");
  const [packageInfo, setPackageInfo] = useState(false);
  const [packageInfoNum, setPackageInfoNum] = useState("");
  const [showLawsuitChecklist, setShowLawsuitChecklist] = useState(false);
  const [showLawsuitChecklistView, setShowLawsuitChecklistView] =
    useState(false);
  const [usersSend5, setUsersSend5] = useState([]);
  const [usersSend6, setUsersSend6] = useState([]);

  const handleShowAddChecklist = (e) => {
    setShowLawsuitChecklist(true);
    setShowLawsuitChecklistView(false);
  };

  const handleShowAddChecklistView = (e) => {
    setShowLawsuitChecklistView(true);
    setShowLawsuitChecklist(false);
  };

  const setFill = (e) => {
    if (fillResponsible) {
      setFillResponsible(false);
    } else {
      setFillResponsible(true);
    }
  };

  const showEditModePost = (e) => {
    setNumNad(e.currentTarget.value);
    setShowEdit(true);
  };

  const closeEditPelnSub = (e) => {
    setShowEditPelnSub(false);
    getData();
  };

  const fetchHolidays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidays(data.filter((el) => el.type === "holiday"));
        fetchUsersSend();
      })
      .catch((error) => {});
  };

  const fetchUsersSend = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUserSend(
          data.filter(
            (el) => +el.team === (+props.team > 0 ? +props.team : 1)
          )[0].user
        );
        fetchUsersSend2();
      })
      .catch((error) => {});
  };

  const fetchUsersSend2 = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUserSend2(
          data.filter(
            (el) => +el.team === (+props.team > 0 ? +props.team : 1)
          )[0].user
        );
        fetchUsersSend4();
      })
      .catch((error) => {});
  };

  const fetchUsersSend4 = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend4", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUserSend4(
          data.filter(
            (el) => +el.team === (+props.team > 0 ? +props.team : 1)
          )[0].user
        );
        fetchFreeDays();
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDays(data);
        fetchUsersSend5();
      })
      .catch((error) => {});
  };

  const fetchUsersSend5 = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend5", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersSend5(data);
        fetchUsersSend6();
      })
      .catch((error) => {});
  };

  const fetchUsersSend6 = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend6", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersSend6(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const checkFree = (date) => {
    var blocks = freeDays.filter((el) => el.date === date);

    var bool = false;

    if (blocks.length > 0) {
      bool = true;
    } else {
      bool = false;
    }

    if (new Date(date).getDay() === 0 || new Date(date).getDay() === 6) {
      bool = true;
    }

    return bool;
  };

  const showClientPopUp = (e) => {
    setShowClientReport(true);
    setClientsReportValue(taskData.clientId);
  };

  const closeClientPopUp = (e) => {
    setShowClientReport(false);
    setClientsReportValue("");
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const deleteCycle = async () => {
    var taskMain = props.team === 1 ? props.tasksData : props.tasksTeam2Data;

    MySwal.fire({
      title: "Czy usunąć przyszłe zadania?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        var toDeleteData = taskMain.filter(
          (el) =>
            +el.id !== props.taskID &&
            new Date(el.final_date) > new Date(taskData.final_date) &&
            el.id !== taskData.id &&
            el.cycleId === taskData.cycleId &&
            (taskData.status === "ZLECONE" || taskData.status === "ZAPLANOWANE")
        );

        var newTaskArr = [];
        taskMain.map(async (el) => {
          if (checkIfDeleteTask(el.id, toDeleteData)) {
            var body = {
              id: el.id,
              user:
                props.user.name !== undefined
                  ? props.user.name
                  : props.uData.name,
            };

            await fetch("https://apidevkppp.ftpeople.pl/deleteTask", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then((data) => {})
              .catch((error) => {});
          } else if (result.isDenied) {
          }
        });
      } else {
        props.closeTaskPopUp();
      }
      props.closeTaskPopUp();
    });
  };

  const closeAdditionalWezw = (e) => {
    setShowAdditionalWezw(false);

    if (checkTaskType(taskData.task)) {
      addTaskIfCond11();
    } else {
      MySwal.fire({
        icon: "success",
        title: "Wykonano",
        text: "zadanie",
      }).then((result) => {
        if (+taskData.cycleId > 0) {
          deleteCycle();
        } else {
          props.closeTaskPopUp();
        }
      });
    }
  };

  const closeAdditionalPozw = (e) => {
    setShowAdditionalPozw(false);

    if (checkTaskType(taskData.task)) {
      addTaskIfCond11();
    } else {
      MySwal.fire({
        icon: "success",
        title: "Wykonano",
        text: "zadanie",
      }).then((result) => {
        if (+taskData.cycleId > 0) {
          deleteCycle();
        } else {
          props.closeTaskPopUp();
        }
      });
    }
  };

  const checkIfDeleteTask = (id, toDeleteData) => {
    var arr = toDeleteData.filter((el) => +el.id === +id);
    if (arr.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const checkTaskType = (task) => {
    var tt = props.tasksTypesData.filter(
      (el) => el.name === task.replaceAll(" - SKD", "")
    )[0];
    if (!tt.addFile) {
      return false;
    }
    if (+tt.addFile === 1) {
      return true;
    }
    return false;
  };

  const saveAcceptTask = async () => {
    var body = {
      id: props.taskID,
      user: props.user.name,
    };

    await fetch("https://apidevkppp.ftpeople.pl/doTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    if (
      taskData.task.replaceAll(" - SKD", "") === "Replika" &&
      taskData.task_conn === "c"
    ) {
      checkRep();
    }

    if (
      (taskData.task.replaceAll(" - SKD", "") === "Skarga kasacyjna" ||
        taskData.task.replaceAll(" - SKD", "") ===
          "Odpowiedź na skargę kasacyjną") &&
      taskData.task_conn === "c"
    ) {
      checkSkarga();
    }

    var end = true;

    if (
      +props.team === 2 &&
      taskData.task.replaceAll(" - SKD", "") === "Mail do klienta SCF - wysłany"
    ) {
      end = false;
      addTaskIfCond1();
    }

    if (taskData.task.replaceAll(" - SKD", "") === "Testowe zadanie - pp") {
      end = false;
      addTaskIfCond13();
    }

    if (
      +props.team === 2 &&
      (taskData.task.replaceAll(" - SKD", "") === "KZP pismem - wysłane" ||
        taskData.task.replaceAll(" - SKD", "") === "KZP mailem - wysłane")
    ) {
      end = false;
      addTaskIfCond2();
    }

    if (taskData.task.replaceAll(" - SKD", "") === "Wysyłka pozwu") {
      end = false;
      addTaskIfCond3();
    }

    if (
      +props.team === 1 &&
      (taskData.task.replaceAll(" - SKD", "") === "Wezwanie do zapłaty" ||
        taskData.task.replaceAll(" - SKD", "") ===
          "Wezwanie do zapłaty z oświadczeniem")
    ) {
      end = false;
      addTaskIfCond4();
    }

    if (
      taskData.task.replaceAll(" - SKD", "") ===
      "Oświadczenie o potrąceniu - kredyt spłacony"
    ) {
      end = false;
      addTaskIfCond4AP();
    }

    if (
      +props.team === 2 &&
      (taskData.task.replaceAll(" - SKD", "") === "Wezwanie do zapłaty" ||
        taskData.task.replaceAll(" - SKD", "") ===
          "Wezwanie do zapłaty z oświadczeniem")
    ) {
      end = false;
      addTaskIfCond5();
    }

    if (
      taskData.task.replaceAll(" - SKD", "") ===
      "Sprawdzić czy apelacja wpłynęła"
    ) {
      end = false;
      addTaskIfCond6();
    }

    if (
      taskData.task.replaceAll(" - SKD", "") ===
      "Sprawdzić na portalu czy jest sygnatura postępowania apelacyjnego"
    ) {
      end = false;
      addTaskIfCond6a();
    }

    if (taskData.task.replaceAll(" - SKD", "") === "Sporządzenie pozwu") {
      end = false;
      addTaskIfCond7();
    }

    if (taskData.task.replaceAll(" - SKD", "") === "Sprawdzenie pozwu") {
      end = false;
      addTaskIfCond8();
    }

    if (
      taskData.task.replaceAll(" - SKD", "") ===
      "Sprawdzenie pozwu do nadania po poprawkach + weryfikacja wydruku"
    ) {
      end = false;
      addTaskIfCond8a();
    }
    if (taskData.task.replaceAll(" - SKD", "") === "Nadanie pozwu") {
      end = false;
      addTaskIfCond8a2();
    }

    if (taskData.task.replaceAll(" - SKD", "") === "Odpowiedź na apelację") {
      end = false;
      addTaskIfCond9();
    }

    if (taskData.task.replaceAll(" - SKD", "") === "Apelacja") {
      end = false;
      addTaskIfCond10();
    }

    if (
      taskData.task.replaceAll(" - SKD", "") ===
      "Odpowiedź na wezwanie do zapłaty"
    ) {
      end = false;
      addTaskIfCond1X();
    }

    if (
      taskData.task.replaceAll(" - SKD", "") ===
      "Wysłać wezwanie o KZP do pełnomocnika banku oraz rozliczenie SCF do klienta"
    ) {
      end = false;
      addTaskIfCond12();
    }

    if (
      taskData.task.replaceAll(" - SKD", "") ===
      "Cofnięcie częściowe pozwu po potrąceniu"
    ) {
      end = false;
      addTaskIfCond14();
    }

    if (end) {
      MySwal.fire({
        title: "Czy chcesz dodać adresata do książki nadawczej?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          setShowSendPost(true);
        } else if (result.isDenied) {
          if (checkTaskType(taskData.task)) {
            addTaskIfCond11();
          } else {
            MySwal.fire({
              icon: "success",
              title: "Wykonano",
              text: "zadanie",
            }).then((result) => {
              if (+taskData.cycleId > 0) {
                deleteCycle();
              } else {
                props.closeTaskPopUp();
              }
            });
          }
        }
      });
    }
  };

  const days = (date_1, date_2) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return TotalDays;
  };

  const addDay = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 30));
    return retDate;
  };

  const addDay3Weeks = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 21));
    return retDate;
  };

  const addDay3Months = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 90));
    return retDate;
  };

  const addDay2Weeks = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 14));
    return retDate;
  };

  const addDayOne = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 1));
    return retDate;
  };

  const addDayTwo = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 2));
    return retDate;
  };

  const addWeeksFour = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 28));
    return retDate;
  };

  const addWeeksTwo = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 14));
    return retDate;
  };

  const addDayFive = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 5));
    return retDate;
  };

  const addDayThree = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 3));
    return retDate;
  };

  const subDay = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() - 30));
    return retDate;
  };

  const addTaskIfCond1 = async (e) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    var dateFinal = new Date();

    var newFinalDate = addDay3Weeks(new Date());
    if (newFinalDate.getDay() === 0) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 1));
    }
    if (newFinalDate.getDay() === 6) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 2));
    }

    var date_final = newFinalDate;

    while (
      (checkFree(date_final) ||
        checkHoliday(taskData.responsible, date_final)) &&
      (date_final.getDay() === 0 || date_final.getDay() === 6)
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var body = {
      responsible: props.user.role === "admin" ? responsible : props.user.name,
      start_date: date_start,
      final_date: dateFinal,
      bank: taskData.bank,
      sygn: taskData.sygn,
      responsible: taskData.responsible,
      client_name: taskData.client_name,
      task: "Premia za sukces - sprawdzić czy zapłacone",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: taskData.court,
      type: "POZASĄDOWE",
      readed: "no",
      addRole: taskData.addRole,
      cycleId: "",
      clientId: taskData.task_conn === "c" ? taskData.clientId : "",
      task_conn: taskData.task_conn,
      team: taskData.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    if (checkTaskType(taskData.task)) {
      addTaskIfCond11();
    } else {
      MySwal.fire({
        title: "Czy chcesz dodać adresata do książki nadawczej?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          setShowSendPost(true);
        } else if (result.isDenied) {
          if (checkTaskType(taskData.task)) {
            addTaskIfCond11();
          } else {
            MySwal.fire({
              icon: "success",
              title: "Wykonano",
              text: "zadanie",
            }).then((result) => {
              if (+taskData.cycleId > 0) {
                deleteCycle();
              } else {
                props.closeTaskPopUp();
              }
            });
          }
        }
      });
    }
  };

  const showCheck = (e) => {
    setPackageInfoNum(e.currentTarget.value);
    setPackageInfo(true);
  };

  const addTaskIfCond1X = async (e) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    var dateFinal = new Date();

    var newFinalDate = addWeeksTwo(new Date());
    if (newFinalDate.getDay() === 0) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 1));
    }
    if (newFinalDate.getDay() === 6) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 2));
    }

    var date_final = newFinalDate;

    while (
      (checkFree(date_final) ||
        checkHoliday(taskData.responsible, date_final)) &&
      (date_final.getDay() === 0 || date_final.getDay() === 6)
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var body = {
      start_date: date_start,
      final_date: dateFinal,
      bank: taskData.bank,
      sygn: taskData.sygn,
      responsible: taskData.responsible,
      client_name: taskData.client_name,
      task: "Sprawdzenie czy klient wysłał podpisaną odpowiedź na wezwanie i potw. nadania oraz należy dodać dokumenty do Workflow",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: taskData.court,
      type: "POZASĄDOWE",
      readed: "no",
      addRole: taskData.addRole,
      cycleId: "",
      clientId: taskData.task_conn === "c" ? taskData.clientId : "",
      task_conn: taskData.task_conn,
      team: taskData.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      title: "Czy chcesz dodać adresata do książki nadawczej?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowSendPost(true);
      } else if (result.isDenied) {
        if (checkTaskType(taskData.task)) {
          addTaskIfCond11();
        } else {
          MySwal.fire({
            icon: "success",
            title: "Wykonano",
            text: "zadanie",
          }).then((result) => {
            if (+taskData.cycleId > 0) {
              deleteCycle();
            } else {
              props.closeTaskPopUp();
            }
          });
        }
      }
    });
  };

  const addTaskIfCond2 = async (e) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    var dateFinal = new Date();

    var newFinalDate = addDay(new Date());
    if (newFinalDate.getDay() === 0) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 1));
    }
    if (newFinalDate.getDay() === 6) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 2));
    }

    var date_final = newFinalDate;

    while (
      (checkFree(date_final) ||
        checkHoliday(taskData.responsible, date_final)) &&
      (date_final.getDay() === 0 || date_final.getDay() === 6)
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var body = {
      start_date: date_start,
      final_date: dateFinal,
      bank: taskData.bank,
      sygn: taskData.sygn,
      responsible: taskData.responsible,
      client_name: taskData.client_name,
      task: "KZP – sprawdzić czy zapłacone",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: taskData.court,
      type: "POZASĄDOWE",
      readed: "no",
      addRole: taskData.addRole,
      cycleId: "",
      clientId: taskData.task_conn === "c" ? taskData.clientId : "",
      task_conn: taskData.task_conn,
      team: taskData.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      title: "Czy chcesz dodać adresata do książki nadawczej?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowSendPost(true);
      } else if (result.isDenied) {
        if (checkTaskType(taskData.task)) {
          addTaskIfCond11();
        } else {
          MySwal.fire({
            icon: "success",
            title: "Wykonano",
            text: "zadanie",
          }).then((result) => {
            if (+taskData.cycleId > 0) {
              deleteCycle();
            } else {
              props.closeTaskPopUp();
            }
          });
        }
      }
    });
  };

  const addTaskIfCond3 = async (e) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    var dateFinal = new Date();

    var newFinalDate = addDayOne(new Date());
    if (newFinalDate.getDay() === 0) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 1));
    }
    if (newFinalDate.getDay() === 6) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 2));
    }

    var date_final = newFinalDate;

    while (
      (checkFree(date_final) ||
        checkHoliday(taskData.responsible, date_final)) &&
      (date_final.getDay() === 0 || date_final.getDay() === 6)
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var body = {
      start_date: date_start,
      final_date: dateFinal,
      bank: taskData.bank,
      sygn: taskData.sygn,
      responsible: taskData.responsible,
      client_name: taskData.client_name,
      task: "Opłata początkowa – sprawdzić czy klient płaci raty terminowo",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: taskData.court,
      type: "POZASĄDOWE",
      readed: "no",
      addRole: taskData.addRole,
      cycleId: "",
      clientId: taskData.task_conn === "c" ? taskData.clientId : "",
      task_conn: taskData.task_conn,
      team: taskData.team,
    };

    var newFinalDate2 = addDayOne(new Date());
    if (newFinalDate2.getDay() === 0) {
      newFinalDate2 = new Date(
        newFinalDate2.setDate(newFinalDate2.getDate() + 1)
      );
    }
    if (newFinalDate2.getDay() === 6) {
      newFinalDate2 = new Date(
        newFinalDate2.setDate(newFinalDate2.getDate() + 2)
      );
    }

    var date_final2 = newFinalDate2;

    while (
      (checkFree(date_final2) ||
        checkHoliday(taskData.responsible, date_final2)) &&
      (date_final2.getDay() === 0 || date_final2.getDay() === 6)
    ) {
      date_final2 = addDayOne(date_final2);
    }

    var dateFinal2 =
      date_final2.getFullYear() +
      "-" +
      (date_final2.getMonth() + 1) +
      "-" +
      date_final2.getDate();

    var body2 = {
      start_date: date_start,
      final_date: dateFinal2,
      bank: taskData.bank,
      sygn: taskData.sygn,
      responsible: client.praw_spr_pozew,
      client_name: taskData.client_name,
      task: "Sprawdzenie pozwu do nadania po poprawkach + weryfikacja wydruku",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: taskData.court,
      type: "POZASĄDOWE",
      readed: "no",
      addRole: taskData.addRole,
      cycleId: "",
      clientId: taskData.task_conn === "c" ? taskData.clientId : "",
      task_conn: taskData.task_conn,
      team: taskData.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body2),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    var source = client ? client.source : "";

    if (source !== "FREJOWSKI CHF") {
      await fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});
    }

    if (taskData.task_conn === "c") {
      var body = {
        status: "wysłano pozew",
        status_note: "",
        id: taskData.clientId,
      };

      await fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      var body5 = {
        id: taskData.clientId,
      };

      fetch("https://apidevkppp.ftpeople.pl/setTasksDLDone", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body5),
      })
        .then((response) => response.text())
        .then(async (data) => {})
        .catch((error) => {});

      var body2 = {
        id: taskData.clientId,
        lawsuit_date:
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1 < 10
            ? "0" + (new Date().getMonth() + 1)
            : new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate()),
      };

      await fetch("https://apidevkppp.ftpeople.pl/addLDClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body2),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Zmieniono status sprawy klienta",
        taskData.clientId
      );

      var body3 = {
        id: taskData.clientId,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getClientsId", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body3),
      })
        .then((response) => response.json())
        .then((data) => {
          var wps = data[0].wps;
          var court = data[0].court;

          if (true) {
            Mozambik15(true);
          } else {
            if (checkTaskType(taskData.task)) {
              addTaskIfCond11();
            } else {
              MySwal.fire({
                icon: "success",
                title: "Wykonano",
                text: "zadanie",
              }).then((result) => {
                if (+taskData.cycleId > 0) {
                  deleteCycle();
                } else {
                  props.closeTaskPopUp();
                }
              });
            }
          }
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        title: "Czy chcesz dodać adresata do książki nadawczej?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          setShowSendPost(true);
        } else if (result.isDenied) {
          if (checkTaskType(taskData.task)) {
            addTaskIfCond11();
          } else {
            MySwal.fire({
              icon: "success",
              title: "Wykonano",
              text: "zadanie",
            }).then((result) => {
              if (+taskData.cycleId > 0) {
                deleteCycle();
              } else {
                props.closeTaskPopUp();
              }
            });
          }
        }
      });
    }
  };

  const addTaskIfCond13 = async (e) => {
    MySwal.fire({
      title: "Czy chcesz dodać adresata do książki nadawczej?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowSendPost(true);
      } else if (result.isDenied) {
        if (checkTaskType(taskData.task)) {
          addTaskIfCond11();
        } else {
          MySwal.fire({
            icon: "success",
            title: "Wykonano",
            text: "zadanie",
          }).then((result) => {
            if (+taskData.cycleId > 0) {
              deleteCycle();
            } else {
              props.closeTaskPopUp();
            }
          });
        }
      }
    });
  };

  const closeSendPost = () => {
    setShowSendPost(false);
    if (!showSendPostButton) {
      addTaskIfCond13();
    } else {
      getData();
    }
  };

  function getNextFriday(date) {
    const dateCopy = new Date(date.getTime());

    const nextFriday = new Date(
      dateCopy.setDate(
        dateCopy.getDate() + ((7 - dateCopy.getDay() + 5) % 7 || 7)
      )
    );

    return nextFriday;
  }

  const addTaskIfCond4 = async (e) => {
    var model = [];

    if (props.team === 0) {
      props.lawyersData.map((element) => {
        model[element.name] = element.name;
      });
    } else {
      props.lawyersData
        .filter((el) => el.team.includes(props.team))
        .map((element) => {
          model[element.name] = element.name;
        });
    }

    MySwal.fire({
      title: "Kto ma sprawdzić wezwanie do zapłaty?",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(function (result) {
      if (result.isConfirmed) {
        var responsibleA = result.value;
        if (client.type === "sankcja kredytu darmowego") {
          MySwal.fire({
            title: "Proszę podać wysokość opłaty sądowej od pozwu",
            html: `
            <input id="swal-input1" type="number" class="swal2-input" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
          `,
            showCancelButton: true,
            cancelButtonText: "Anuluj",
            preConfirm: () => {
              return document.getElementById("swal-input1").value;
            },
          }).then(async function (resultX) {
            var value = resultX.value;
            var bodyX = {
              id: client.id,
              value: value,
            };

            fetch("https://apidevkppp.ftpeople.pl/updateOpSp", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(bodyX),
            })
              .then((response) => response.text())
              .then(async (responseJson) => {
                var date_startA =
                  new Date().getFullYear() +
                  "-" +
                  (new Date().getMonth() + 1) +
                  "-" +
                  new Date().getDate();

                var newFinalDate = addDayThree(new Date());
                if (newFinalDate.getDay() === 0) {
                  newFinalDate = new Date(
                    newFinalDate.setDate(newFinalDate.getDate() + 1)
                  );
                }
                if (newFinalDate.getDay() === 6) {
                  newFinalDate = new Date(
                    newFinalDate.setDate(newFinalDate.getDate() + 2)
                  );
                }

                var date_final = newFinalDate;

                while (
                  (checkFree(date_final) ||
                    checkHoliday(responsibleA, date_final)) &&
                  (date_final.getDay() === 0 || date_final.getDay() === 6)
                ) {
                  date_final = addDayOne(date_final);
                }

                dateFinal =
                  date_final.getFullYear() +
                  "-" +
                  (date_final.getMonth() + 1) +
                  "-" +
                  date_final.getDate();

                var body3 = {
                  responsible: responsibleA,
                  start_date: date_startA,
                  final_date: dateFinal,
                  bank: taskData.bank,
                  sygn: taskData.sygn,
                  client_name: taskData.client_name,
                  task: "Sprawdzenie wezwanie do zapłaty",
                  date_added: date_added,
                  user_added: props.user.name,
                  status: "ZLECONE",
                  court: taskData.court,
                  type: "POZASĄDOWE",
                  readed: "no",
                  addRole: taskData.addRole,
                  cycleId: "",
                  clientId: taskData.task_conn === "c" ? taskData.clientId : "",
                  task_conn: taskData.task_conn,
                  team: taskData.team,
                  note: "",
                };

                fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(body3),
                })
                  .then((response) => response.json())
                  .then((data) => {})
                  .catch((error) => {});

                var date_added =
                  new Date().getFullYear() +
                  "-" +
                  (new Date().getMonth() + 1) +
                  "-" +
                  new Date().getDate() +
                  " " +
                  new Date().getHours() +
                  ":" +
                  new Date().getMinutes();
                var date_start =
                  new Date().getFullYear() +
                  "-" +
                  (new Date().getMonth() + 1) +
                  "-" +
                  new Date().getDate();
                var dateFinal = new Date();

                if (taskData.task_conn === "c") {
                  var body2 = {
                    id: taskData.clientId,
                    data_wezw:
                      new Date().getFullYear() +
                      "-" +
                      (new Date().getMonth() + 1 < 10
                        ? "0" + (new Date().getMonth() + 1)
                        : new Date().getMonth() + 1) +
                      "-" +
                      (new Date().getDate() < 10
                        ? "0" + new Date().getDate()
                        : new Date().getDate()),
                  };

                  fetch("https://apidevkppp.ftpeople.pl/addDWClient", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(body2),
                  })
                    .then((response) => response.json())
                    .then((data) => {
                      return;
                    })
                    .catch((error) => {});
                }

                if (taskData.task_conn === "c") {
                  var newFinalDate = getNextFriday(new Date());
                  if (newFinalDate.getDay() === 0) {
                    newFinalDate = new Date(
                      newFinalDate.setDate(newFinalDate.getDate() + 1)
                    );
                  }
                  if (newFinalDate.getDay() === 6) {
                    newFinalDate = new Date(
                      newFinalDate.setDate(newFinalDate.getDate() + 2)
                    );
                  }

                  var date_final = newFinalDate;

                  while (
                    (checkFree(date_final) ||
                      checkHoliday("Marta Kurzyk", date_final)) &&
                    (date_final.getDay() === 0 || date_final.getDay() === 6)
                  ) {
                    date_final = addDayOne(date_final);
                  }

                  dateFinal =
                    date_final.getFullYear() +
                    "-" +
                    (date_final.getMonth() + 1) +
                    "-" +
                    date_final.getDate();

                  var body = {
                    responsible:
                      +props.team === 1
                        ? usersSend5.filter((el) => +el.team === 1)[0].user
                        : usersSend5.filter((el) => +el.team === 2)[0].user,
                    start_date: date_start,
                    final_date: dateFinal,
                    bank: taskData.bank,
                    sygn: taskData.sygn,
                    client_name: taskData.client_name,
                    task: "Opłata od pozwu – wysłać dane do klienta",
                    date_added: date_added,
                    user_added: props.user.name,
                    status: "ZLECONE",
                    court: taskData.court,
                    type: "POZASĄDOWE",
                    readed: "no",
                    addRole: taskData.addRole,
                    cycleId: "",
                    clientId:
                      taskData.task_conn === "c" ? taskData.clientId : "",
                    task_conn: taskData.task_conn,
                    team: taskData.team,
                    note: "",
                  };

                  fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(body),
                  })
                    .then((response) => response.json())
                    .then((data) => {})
                    .catch((error) => {});
                }

                if (taskData.task_conn === "c") {
                  MySwal.fire({
                    title: "Czy chcesz zmienić satus sprawy?",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "Tak",
                    denyButtonText: `Nie`,
                  }).then(async (result) => {
                    if (result.isConfirmed) {
                      setShowAdditionalWezw(true);
                    } else if (result.isDenied) {
                      if (!taskData.postNumber) {
                        MySwal.fire({
                          title:
                            "Czy chcesz dodać adresata do książki nadawczej?",
                          showDenyButton: true,
                          showCancelButton: false,
                          confirmButtonText: "Tak",
                          denyButtonText: `Nie`,
                        }).then(async (result) => {
                          if (result.isConfirmed) {
                            setShowSendPost(true);
                          } else if (result.isDenied) {
                            if (checkTaskType(taskData.task)) {
                              addTaskIfCond11();
                            } else {
                              MySwal.fire({
                                icon: "success",
                                title: "Wykonano",
                                text: "zadanie",
                              }).then((result) => {
                                if (+taskData.cycleId > 0) {
                                  deleteCycle();
                                } else {
                                  props.closeTaskPopUp();
                                }
                              });
                            }
                          }
                        });
                      } else {
                        if (checkTaskType(taskData.task)) {
                          addTaskIfCond11();
                        } else {
                          MySwal.fire({
                            icon: "success",
                            title: "Wykonano",
                            text: "zadanie",
                          }).then((result) => {
                            if (+taskData.cycleId > 0) {
                              deleteCycle();
                            } else {
                              props.closeTaskPopUp();
                            }
                          });
                        }
                      }
                    }
                  });
                } else {
                  MySwal.fire({
                    icon: "success",
                    title: "Wykonano",
                    text: "zadanie",
                  }).then((result) => {
                    if (+taskData.cycleId > 0) {
                      deleteCycle();
                    } else {
                      props.closeTaskPopUp();
                    }
                  });
                }
              });
          });
        } else {
          var date_startA =
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1) +
            "-" +
            new Date().getDate();

          var newFinalDate = addDayThree(new Date());
          if (newFinalDate.getDay() === 0) {
            newFinalDate = new Date(
              newFinalDate.setDate(newFinalDate.getDate() + 1)
            );
          }
          if (newFinalDate.getDay() === 6) {
            newFinalDate = new Date(
              newFinalDate.setDate(newFinalDate.getDate() + 2)
            );
          }

          var date_final = newFinalDate;

          while (
            (checkFree(date_final) || checkHoliday(responsibleA, date_final)) &&
            (date_final.getDay() === 0 || date_final.getDay() === 6)
          ) {
            date_final = addDayOne(date_final);
          }

          dateFinal =
            date_final.getFullYear() +
            "-" +
            (date_final.getMonth() + 1) +
            "-" +
            date_final.getDate();

          var body3 = {
            responsible: responsibleA,
            start_date: date_startA,
            final_date: dateFinal,
            bank: taskData.bank,
            sygn: taskData.sygn,
            client_name: taskData.client_name,
            task: "Sprawdzenie wezwanie do zapłaty",
            date_added: date_added,
            user_added: props.user.name,
            status: "ZLECONE",
            court: taskData.court,
            type: "POZASĄDOWE",
            readed: "no",
            addRole: taskData.addRole,
            cycleId: "",
            clientId: taskData.task_conn === "c" ? taskData.clientId : "",
            task_conn: taskData.task_conn,
            team: taskData.team,
            note: "",
          };

          fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body3),
          })
            .then((response) => response.json())
            .then((data) => {})
            .catch((error) => {});

          var date_added =
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1) +
            "-" +
            new Date().getDate() +
            " " +
            new Date().getHours() +
            ":" +
            new Date().getMinutes();
          var date_start =
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1) +
            "-" +
            new Date().getDate();
          var dateFinal = new Date();

          if (taskData.task_conn === "c") {
            var body2 = {
              id: taskData.clientId,
              data_wezw:
                new Date().getFullYear() +
                "-" +
                (new Date().getMonth() + 1 < 10
                  ? "0" + (new Date().getMonth() + 1)
                  : new Date().getMonth() + 1) +
                "-" +
                (new Date().getDate() < 10
                  ? "0" + new Date().getDate()
                  : new Date().getDate()),
            };

            fetch("https://apidevkppp.ftpeople.pl/addDWClient", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body2),
            })
              .then((response) => response.json())
              .then((data) => {
                return;
              })
              .catch((error) => {});
          }

          if (taskData.task_conn === "c") {
            var newFinalDate = getNextFriday(new Date());
            if (newFinalDate.getDay() === 0) {
              newFinalDate = new Date(
                newFinalDate.setDate(newFinalDate.getDate() + 1)
              );
            }
            if (newFinalDate.getDay() === 6) {
              newFinalDate = new Date(
                newFinalDate.setDate(newFinalDate.getDate() + 2)
              );
            }

            var date_final = newFinalDate;

            while (
              (checkFree(date_final) ||
                checkHoliday("Marta Kurzyk", date_final)) &&
              (date_final.getDay() === 0 || date_final.getDay() === 6)
            ) {
              date_final = addDayOne(date_final);
            }

            dateFinal =
              date_final.getFullYear() +
              "-" +
              (date_final.getMonth() + 1) +
              "-" +
              date_final.getDate();

            var body = {
              responsible:
                +props.team === 1
                  ? usersSend5.filter((el) => +el.team === 1)[0].user
                  : usersSend5.filter((el) => +el.team === 2)[0].user,
              start_date: date_start,
              final_date: dateFinal,
              bank: taskData.bank,
              sygn: taskData.sygn,
              client_name: taskData.client_name,
              task: "Opłata od pozwu – wysłać dane do klienta",
              date_added: date_added,
              user_added: props.user.name,
              status: "ZLECONE",
              court: taskData.court,
              type: "POZASĄDOWE",
              readed: "no",
              addRole: taskData.addRole,
              cycleId: "",
              clientId: taskData.task_conn === "c" ? taskData.clientId : "",
              task_conn: taskData.task_conn,
              team: taskData.team,
              note: "",
            };

            fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then((data) => {})
              .catch((error) => {});
          }

          if (taskData.task_conn === "c") {
            MySwal.fire({
              title: "Czy chcesz zmienić satus sprawy?",
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: "Tak",
              denyButtonText: `Nie`,
            }).then(async (result) => {
              if (result.isConfirmed) {
                setShowAdditionalWezw(true);
              } else if (result.isDenied) {
                if (!taskData.postNumber) {
                  MySwal.fire({
                    title: "Czy chcesz dodać adresata do książki nadawczej?",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "Tak",
                    denyButtonText: `Nie`,
                  }).then(async (result) => {
                    if (result.isConfirmed) {
                      setShowSendPost(true);
                    } else if (result.isDenied) {
                      if (checkTaskType(taskData.task)) {
                        addTaskIfCond11();
                      } else {
                        MySwal.fire({
                          icon: "success",
                          title: "Wykonano",
                          text: "zadanie",
                        }).then((result) => {
                          if (+taskData.cycleId > 0) {
                            deleteCycle();
                          } else {
                            props.closeTaskPopUp();
                          }
                        });
                      }
                    }
                  });
                } else {
                  if (checkTaskType(taskData.task)) {
                    addTaskIfCond11();
                  } else {
                    MySwal.fire({
                      icon: "success",
                      title: "Wykonano",
                      text: "zadanie",
                    }).then((result) => {
                      if (+taskData.cycleId > 0) {
                        deleteCycle();
                      } else {
                        props.closeTaskPopUp();
                      }
                    });
                  }
                }
              }
            });
          } else {
            MySwal.fire({
              icon: "success",
              title: "Wykonano",
              text: "zadanie",
            }).then((result) => {
              if (+taskData.cycleId > 0) {
                deleteCycle();
              } else {
                props.closeTaskPopUp();
              }
            });
          }
        }
      } else {
        props.close();
      }
    });
  };

  const addTaskIfCond4AP = async (e) => {
    var model = [];

    if (props.team === 0) {
      props.lawyersData.map((element) => {
        model[element.name] = element.name;
      });
    } else {
      props.lawyersData
        .filter((el) => el.team.includes(props.team))
        .map((element) => {
          model[element.name] = element.name;
        });
    }

    MySwal.fire({
      title: "Kto ma sprawdzić oświadczenie?",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(function (result) {
      if (result.isConfirmed) {
        var responsibleA = result.value;

        var date_startA =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate();

        var dateFinal = new Date();

        var newFinalDate = addDayOne(new Date());
        if (newFinalDate.getDay() === 0) {
          newFinalDate = new Date(
            newFinalDate.setDate(newFinalDate.getDate() + 1)
          );
        }
        if (newFinalDate.getDay() === 6) {
          newFinalDate = new Date(
            newFinalDate.setDate(newFinalDate.getDate() + 2)
          );
        }

        var date_final = newFinalDate;

        while (
          (checkFree(date_final) || checkHoliday(responsibleA, date_final)) &&
          (date_final.getDay() === 0 || date_final.getDay() === 6)
        ) {
          date_final = addDayOne(date_final);
        }

        dateFinal =
          date_final.getFullYear() +
          "-" +
          (date_final.getMonth() + 1) +
          "-" +
          date_final.getDate();

        var body3 = {
          responsible: responsibleA,
          start_date: date_startA,
          final_date: dateFinal,
          bank: taskData.bank,
          sygn: taskData.sygn,
          client_name: taskData.client_name,
          task: "Sprawdzenie oświadczenia o potrąceniu",
          date_added: new Date(),
          user_added: props.user.name,
          status: "ZLECONE",
          court: taskData.court,
          type: "POZASĄDOWE",
          readed: "no",
          addRole: taskData.addRole,
          cycleId: "",
          clientId: taskData.task_conn === "c" ? taskData.clientId : "",
          task_conn: taskData.task_conn,
          team: taskData.team,
          note: "",
        };

        fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body3),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        var bodyX = {
          id: taskData.clientId,
          date: "TAK",
        };

        fetch("https://apidevkppp.ftpeople.pl/updatePozN", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(bodyX),
        })
          .then((response) => response.text())
          .then((responseJson) => {
            MySwal.fire({
              title: "Czy chcesz dodać adresata do książki nadawczej?",
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: "Tak",
              denyButtonText: `Nie`,
            }).then(async (result) => {
              if (result.isConfirmed) {
                setShowSendPost(true);
              } else if (result.isDenied) {
                if (checkTaskType(taskData.task)) {
                  addTaskIfCond11();
                } else {
                  MySwal.fire({
                    icon: "success",
                    title: "Wykonano",
                    text: "zadanie",
                  }).then((result) => {
                    if (+taskData.cycleId > 0) {
                      deleteCycle();
                    } else {
                      props.closeTaskPopUp();
                    }
                  });
                }
              }
            });
          });
      } else {
        props.close();
      }
    });
  };

  const addTaskIfCond5 = async (e) => {
    var model = [];

    if (props.team === 0) {
      props.lawyersData.map((element) => {
        model[element.name] = element.name;
      });
    } else {
      props.lawyersData
        .filter((el) => el.team.includes(props.team))
        .map((element) => {
          model[element.name] = element.name;
        });
    }

    MySwal.fire({
      title: "Kto ma sprawdzić wezwanie do zapłaty?",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(function (result) {
      if (result.isConfirmed) {
        var responsibleA = result.value;

        var date_startA =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate();

        var newFinalDate = addDayThree(new Date());
        if (newFinalDate.getDay() === 0) {
          newFinalDate = new Date(
            newFinalDate.setDate(newFinalDate.getDate() + 1)
          );
        }
        if (newFinalDate.getDay() === 6) {
          newFinalDate = new Date(
            newFinalDate.setDate(newFinalDate.getDate() + 2)
          );
        }

        var date_final = newFinalDate;

        while (
          (checkFree(date_final) || checkHoliday(responsibleA, date_final)) &&
          (date_final.getDay() === 0 || date_final.getDay() === 6)
        ) {
          date_final = addDayOne(date_final);
        }

        dateFinal =
          date_final.getFullYear() +
          "-" +
          (date_final.getMonth() + 1) +
          "-" +
          date_final.getDate();

        var body3 = {
          responsible: responsibleA,
          start_date: date_startA,
          final_date: dateFinal,
          bank: taskData.bank,
          sygn: taskData.sygn,
          client_name: taskData.client_name,
          task: "Sprawdzenie wezwanie do zapłaty",
          date_added: date_added,
          user_added: props.user.name,
          status: "ZLECONE",
          court: taskData.court,
          type: "POZASĄDOWE",
          readed: "no",
          addRole: taskData.addRole,
          cycleId: "",
          clientId: taskData.task_conn === "c" ? taskData.clientId : "",
          task_conn: taskData.task_conn,
          team: taskData.team,
          note: "",
        };

        fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body3),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        if (taskData.task_conn === "c") {
          var body2 = {
            id: taskData.clientId,
            data_wezw:
              new Date().getFullYear() +
              "-" +
              (new Date().getMonth() + 1 < 10
                ? "0" + (new Date().getMonth() + 1)
                : new Date().getMonth() + 1) +
              "-" +
              (new Date().getDate() < 10
                ? "0" + new Date().getDate()
                : new Date().getDate()),
          };

          fetch("https://apidevkppp.ftpeople.pl/addDWClient", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body2),
          })
            .then((response) => response.json())
            .then((data) => {
              return;
            })
            .catch((error) => {});
        }

        var date_added =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate() +
          " " +
          new Date().getHours() +
          ":" +
          new Date().getMinutes();
        var date_start =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate();
        var dateFinal = new Date();

        var newFinalDate = addDayTwo(new Date());
        if (newFinalDate.getDay() === 0) {
          newFinalDate = new Date(
            newFinalDate.setDate(newFinalDate.getDate() + 1)
          );
        }
        if (newFinalDate.getDay() === 6) {
          newFinalDate = new Date(
            newFinalDate.setDate(newFinalDate.getDate() + 2)
          );
        }

        var date_final = newFinalDate;

        while (
          (checkFree(date_final) ||
            checkHoliday(taskData.responsible, date_final)) &&
          (date_final.getDay() === 0 || date_final.getDay() === 6)
        ) {
          date_final = addDayOne(date_final);
        }

        dateFinal =
          date_final.getFullYear() +
          "-" +
          (date_final.getMonth() + 1) +
          "-" +
          date_final.getDate();

        var body = {
          responsible: taskData.responsible,
          start_date: date_start,
          final_date: dateFinal,
          bank: taskData.bank,
          sygn: taskData.sygn,
          client_name: taskData.client_name,
          task: "Sprawdzenie kompletności dokumentów do pozwu + wezwanie klienta o opłatę od pozwu",
          date_added: date_added,
          user_added: props.user.name,
          status: "ZLECONE",
          court: taskData.court,
          type: "POZASĄDOWE",
          readed: "no",
          addRole: taskData.addRole,
          cycleId: "",
          clientId: taskData.task_conn === "c" ? taskData.clientId : "",
          task_conn: taskData.task_conn,
          team: taskData.team,
          note: "",
        };

        fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        if (taskData.task_conn === "c") {
          MySwal.fire({
            title: "Czy chcesz zmienić satus sprawy?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Tak",
            denyButtonText: `Nie`,
          }).then(async (result) => {
            if (result.isConfirmed) {
              setShowAdditionalWezw(true);
            } else if (result.isDenied) {
              MySwal.fire({
                title: "Czy chcesz dodać adresata do książki nadawczej?",
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: "Tak",
                denyButtonText: `Nie`,
              }).then(async (result) => {
                if (result.isConfirmed) {
                  setShowSendPost(true);
                } else if (result.isDenied) {
                  if (checkTaskType(taskData.task)) {
                    addTaskIfCond11();
                  } else {
                    MySwal.fire({
                      icon: "success",
                      title: "Wykonano",
                      text: "zadanie",
                    }).then((result) => {
                      if (+taskData.cycleId > 0) {
                        deleteCycle();
                      } else {
                        props.closeTaskPopUp();
                      }
                    });
                  }
                }
              });
            }
          });
        } else {
        }
      }
    });
  };

  const checkRep = async () => {
    var body = {
      id: taskData.clientId,
      rep: "TAK",
    };

    await fetch("https://apidevkppp.ftpeople.pl/addRClient", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  const checkSkarga = async () => {
    var body = {
      status: "skarga kasacyjna banku",
      status_note: "",
      id: taskData.clientId,
    };

    fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        return;
      })
      .catch((error) => {});
  };

  const addTaskIfCond6 = async (e) => {
    if (taskData.task_conn === "c") {
      var model = [];

      model["przegrana w I instancji - wnieśliśmy apelację"] =
        "przegrana w I instancji - wnieśliśmy apelację";
      model["wygrana w I. instancji - wnieśliśmy apelację"] =
        "wygrana w I. instancji - wnieśliśmy apelację";
      model["wygrana w I. instancji - apelacja obustronna"] =
        "wygrana w I. instancji - apelacja obustronna";
      model["wygrana w I instancji - wpłynęła apelacja"] =
        "wygrana w I instancji - wpłynęła apelacja";

      var date_added =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes();
      var date_start =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate();
      var dateFinal = new Date();

      var newFinalDate = addDay(new Date());
      if (newFinalDate.getDay() === 0) {
        newFinalDate = new Date(
          newFinalDate.setDate(newFinalDate.getDate() + 1)
        );
      }
      if (newFinalDate.getDay() === 6) {
        newFinalDate = new Date(
          newFinalDate.setDate(newFinalDate.getDate() + 2)
        );
      }

      var date_final = newFinalDate;

      while (
        (checkFree(date_final) ||
          checkHoliday(
            props.user.role === "admin" ? responsible : props.user.name,
            date_final
          )) &&
        (date_final.getDay() === 0 || date_final.getDay() === 6)
      ) {
        date_final = addDayOne(date_final);
      }

      dateFinal =
        date_final.getFullYear() +
        "-" +
        (date_final.getMonth() + 1) +
        "-" +
        date_final.getDate();

      var body = {
        responsible:
          props.user.role === "admin" ? responsible : props.user.name,
        start_date: date_start,
        final_date: dateFinal,
        bank: taskData.bank,
        sygn: taskData.sygn,
        responsible: taskData.responsible,
        client_name: taskData.client_name,
        task: "Sprawdzić na portalu czy jest sygnatura postępowania apelacyjnego",
        date_added: date_added,
        user_added: props.user.name,
        status: "ZLECONE",
        court: taskData.court,
        type: "POZASĄDOWE",
        readed: "no",
        addRole: taskData.addRole,
        cycleId: "",
        clientId: taskData.task_conn === "c" ? taskData.clientId : "",
        task_conn: taskData.task_conn,
        team: taskData.team,
        note: "",
      };

      await fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});
      MySwal.fire({
        title: "Czy chcesz dodać adresata do książki nadawczej?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          setShowSendPost(true);
        } else if (result.isDenied) {
          if (checkTaskType(taskData.task)) {
            addTaskIfCond11();
          } else {
            MySwal.fire({
              icon: "success",
              title: "Wykonano",
              text: "zadanie",
            }).then((result) => {
              if (+taskData.cycleId > 0) {
                deleteCycle();
              } else {
                props.closeTaskPopUp();
              }
            });
          }
        }
      });
    }
  };

  const addTaskIfCond6a = async (e) => {
    if (taskData.task_conn === "c") {
      var model = [];

      model["przegrana w I instancji - wnieśliśmy apelację"] =
        "przegrana w I instancji - wnieśliśmy apelację";
      model["wygrana w I. instancji - wnieśliśmy apelację"] =
        "wygrana w I. instancji - wnieśliśmy apelację";
      model["wygrana w I. instancji - apelacja obustronna"] =
        "wygrana w I. instancji - apelacja obustronna";
      model["wygrana w I instancji - wpłynęła apelacja"] =
        "wygrana w I instancji - wpłynęła apelacja";

      MySwal.fire({
        title: "Wybierz nowy status",
        input: "select",
        inputOptions: model,
        inputPlaceholder: "wybierz status",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value !== "") {
              resolve();
            } else {
              resolve("musisz wybrać status");
            }
          });
        },
      }).then(async function (result) {
        if (result.isConfirmed) {
          var body = {
            status: result.value,
            status_note: "",
            id: taskData.clientId,
          };

          fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.text())
            .then(async (data) => {
              if (checkTaskType(taskData.task)) {
                addTaskIfCond11();
              } else {
                MySwal.fire({
                  icon: "success",
                  title: "Wykonano",
                  text: "zadanie",
                }).then((result) => {
                  if (+taskData.cycleId > 0) {
                    deleteCycle();
                  } else {
                    props.closeTaskPopUp();
                  }
                });
              }
            })
            .catch((error) => {});
        } else if (result.isDismissed || result.isDenied) {
          if (checkTaskType(taskData.task)) {
            addTaskIfCond11();
          } else {
            MySwal.fire({
              icon: "success",
              title: "Wykonano",
              text: "zadanie",
            }).then((result) => {
              if (+taskData.cycleId > 0) {
                deleteCycle();
              } else {
                props.closeTaskPopUp();
              }
            });
          }
        }
      });
    }
  };

  const addTaskIfCond7 = async (e) => {
    if (taskData.task_conn === "c") {
      var model = [];

      props.lawyersData
        .filter((el) => el.team.includes(props.team))
        .map((element) => {
          model[element.name] = element.name;
        });

      MySwal.fire({
        title: "Wybierz pracownika",
        input: "select",
        inputOptions: model,
        inputPlaceholder: "wybierz pracownika",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value !== "") {
              resolve();
            } else {
              resolve("musisz wybrać pracownika");
            }
          });
        },
      }).then(function (result) {
        if (result.isConfirmed) {
          var body4 = {
            id: taskData.clientId,
            praw_spr_pozew: result.value,
          };

          fetch("https://apidevkppp.ftpeople.pl/addPSPClient", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body4),
          })
            .then((response) => response.json())
            .then((data) => {
              return;
            })
            .catch((error) => {});

          var date_added =
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1) +
            "-" +
            new Date().getDate() +
            " " +
            new Date().getHours() +
            ":" +
            new Date().getMinutes();
          var date_start =
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1) +
            "-" +
            new Date().getDate();
          var dateFinal = new Date();

          var newFinalDate = addDayFive(new Date());
          if (newFinalDate.getDay() === 0) {
            newFinalDate = new Date(
              newFinalDate.setDate(newFinalDate.getDate() + 1)
            );
          }
          if (newFinalDate.getDay() === 6) {
            newFinalDate = new Date(
              newFinalDate.setDate(newFinalDate.getDate() + 2)
            );
          }

          var date_final = newFinalDate;

          while (
            (checkFree(date_final) || checkHoliday(result.value, date_final)) &&
            (date_final.getDay() === 0 || date_final.getDay() === 6)
          ) {
            date_final = addDayOne(date_final);
          }

          dateFinal =
            date_final.getFullYear() +
            "-" +
            (date_final.getMonth() + 1) +
            "-" +
            date_final.getDate();

          var body5 = {
            responsible: result.value,
            start_date: date_start,
            final_date: dateFinal,
            bank: taskData.bank,
            sygn: taskData.sygn,
            client_name: taskData.client_name,
            task: "Sprawdzenie pozwu",
            date_added: date_added,
            user_added: props.user.name,
            status: "ZLECONE",
            court: taskData.court,
            type: "POZASĄDOWE",
            readed: "no",
            addRole: taskData.addRole,
            cycleId: "",
            clientId: taskData.task_conn === "c" ? taskData.clientId : "",
            task_conn: taskData.task_conn,
            team: taskData.team,
            note: "",
          };

          fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body5),
          })
            .then((response) => response.json())
            .then((data) => {})
            .catch((error) => {});

          MySwal.fire({
            title: "Czy chcesz uzupełnić checklistę do pozwu?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Tak",
            denyButtonText: `Nie`,
          }).then(async (result) => {
            if (result.isConfirmed) {
              setShowChecklist(true);
            } else if (result.isDenied) {
              MySwal.fire({
                title: "Czy chcesz dodać adresata do książki nadawczej?",
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: "Tak",
                denyButtonText: `Nie`,
              }).then(async (result) => {
                if (result.isConfirmed) {
                  setShowSendPost(true);
                } else if (result.isDenied) {
                  if (checkTaskType(taskData.task)) {
                    addTaskIfCond11();
                  } else {
                    MySwal.fire({
                      icon: "success",
                      title: "Wykonano",
                      text: "zadanie",
                    }).then((result) => {
                      if (+taskData.cycleId > 0) {
                        deleteCycle();
                      } else {
                        props.closeTaskPopUp();
                      }
                    });
                  }
                }
              });
            }
          });
          return;
        }
      });
    }
  };

  const closeCheckList = (e) => {
    setShowChecklist(false);
    MySwal.fire({
      title: "Czy chcesz dodać adresata do książki nadawczej?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowSendPost(true);
      } else if (result.isDenied) {
        if (checkTaskType(taskData.task)) {
          addTaskIfCond11();
        } else {
          MySwal.fire({
            icon: "success",
            title: "Wykonano",
            text: "zadanie",
          }).then((result) => {
            if (+taskData.cycleId > 0) {
              deleteCycle();
            } else {
              props.closeTaskPopUp();
            }
          });
        }
      }
    });
  };

  const addTaskIfCond8 = async (e) => {
    if (taskData.task_conn === "c") {
      var body = {
        id: taskData.clientId,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getPPClientId", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then(async (data) => {
          var body2 = {
            user: data[0].praw_pozew,
          };

          await fetch("https://apidevkppp.ftpeople.pl/getAllowedUser", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body2),
          })
            .then((response) => response.json())
            .then(async (data2) => {
              var allowed = data2[0];

              var date_added =
                new Date().getFullYear() +
                "-" +
                (new Date().getMonth() + 1) +
                "-" +
                new Date().getDate() +
                " " +
                new Date().getHours() +
                ":" +
                new Date().getMinutes();
              var date_start =
                new Date().getFullYear() +
                "-" +
                (new Date().getMonth() + 1) +
                "-" +
                new Date().getDate();
              var dateFinal = new Date();

              var newFinalDate = addDayTwo(new Date());
              if (newFinalDate.getDay() === 0) {
                newFinalDate = new Date(
                  newFinalDate.setDate(newFinalDate.getDate() + 1)
                );
              }
              if (newFinalDate.getDay() === 6) {
                newFinalDate = new Date(
                  newFinalDate.setDate(newFinalDate.getDate() + 2)
                );
              }

              var date_final = newFinalDate;

              while (
                (checkFree(date_final) ||
                  checkHoliday(data[0].praw_pozew, date_final)) &&
                (date_final.getDay() === 0 || date_final.getDay() === 6)
              ) {
                date_final = addDayOne(date_final);
              }

              dateFinal =
                date_final.getFullYear() +
                "-" +
                (date_final.getMonth() + 1) +
                "-" +
                date_final.getDate();

              var resp =
                allowed.allowedClients === "all"
                  ? data[0].praw_pozew
                  : userSend;

              var body5 = {
                responsible: resp,
                start_date: date_start,
                final_date: dateFinal,
                bank: taskData.bank,
                sygn: taskData.sygn,
                client_name: taskData.client_name,
                task: "Wysyłka pozwu",
                date_added: date_added,
                user_added: props.user.name,
                status: "ZLECONE",
                court: taskData.court,
                type: "POZASĄDOWE",
                readed: "no",
                addRole: taskData.addRole,
                cycleId: "",
                clientId: taskData.task_conn === "c" ? taskData.clientId : "",
                task_conn: taskData.task_conn,
                team: taskData.team,
                note: "",
              };

              fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body5),
              })
                .then((response) => response.json())
                .then((data) => {})
                .catch((error) => {});
            });
        })
        .catch((error) => {});
    }

    MySwal.fire({
      title: "Czy chcesz dodać adresata do książki nadawczej?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowSendPost(true);
      } else if (result.isDenied) {
        if (checkTaskType(taskData.task)) {
          addTaskIfCond11();
        } else {
          MySwal.fire({
            icon: "success",
            title: "Wykonano",
            text: "zadanie",
          }).then((result) => {
            if (+taskData.cycleId > 0) {
              deleteCycle();
            } else {
              props.closeTaskPopUp();
            }
          });
        }
      }
    });
  };

  const addTaskIfCond8a = async (e) => {
    if (taskData.task_conn === "c") {
      var bodyD = {
        id: taskData.clientId,
        superNote: taskData.note_task,
      };

      fetch("https://apidevkppp.ftpeople.pl/addTaskNoteChecklist", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(bodyD),
      })
        .then((response) => response.json())
        .then(async (data) => {});

      var body = {
        id: taskData.clientId,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getPPClientId", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then(async (data) => {
          var body2 = {
            user: data[0].praw_pozew,
          };

          await fetch("https://apidevkppp.ftpeople.pl/getAllowedUser", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body2),
          })
            .then((response) => response.json())
            .then(async (data2) => {
              var allowed = data2[0];

              var date_added =
                new Date().getFullYear() +
                "-" +
                (new Date().getMonth() + 1) +
                "-" +
                new Date().getDate() +
                " " +
                new Date().getHours() +
                ":" +
                new Date().getMinutes();
              var date_start =
                new Date().getFullYear() +
                "-" +
                (new Date().getMonth() + 1) +
                "-" +
                new Date().getDate();
              var dateFinal = new Date();

              var newFinalDate = addDayTwo(new Date());
              if (newFinalDate.getDay() === 0) {
                newFinalDate = new Date(
                  newFinalDate.setDate(newFinalDate.getDate() + 1)
                );
              }
              if (newFinalDate.getDay() === 6) {
                newFinalDate = new Date(
                  newFinalDate.setDate(newFinalDate.getDate() + 2)
                );
              }

              var date_final = newFinalDate;

              while (
                (checkFree(date_final) ||
                  checkHoliday(data[0].praw_pozew, date_final)) &&
                (date_final.getDay() === 0 || date_final.getDay() === 6)
              ) {
                date_final = addDayOne(date_final);
              }

              dateFinal =
                date_final.getFullYear() +
                "-" +
                (date_final.getMonth() + 1) +
                "-" +
                date_final.getDate();

              var resp = userSend2;

              var body5 = {
                responsible: resp,
                start_date: date_start,
                final_date: dateFinal,
                bank: taskData.bank,
                sygn: taskData.sygn,
                client_name: taskData.client_name,
                task: "Nadanie pozwu",
                date_added: date_added,
                user_added: props.user.name,
                status: "ZLECONE",
                court: taskData.court,
                type: "POZASĄDOWE",
                readed: "no",
                addRole: taskData.addRole,
                cycleId: "",
                clientId: taskData.task_conn === "c" ? taskData.clientId : "",
                task_conn: taskData.task_conn,
                team: taskData.team,
                note: "",
              };

              fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body5),
              })
                .then((response) => response.json())
                .then((data) => {})
                .catch((error) => {});
            });
        })
        .catch((error) => {});
    }

    MySwal.fire({
      title: "Czy chcesz dodać adresata do książki nadawczej?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowSendPost(true);
      } else if (result.isDenied) {
        if (checkTaskType(taskData.task)) {
          addTaskIfCond11();
        } else {
          MySwal.fire({
            icon: "success",
            title: "Wykonano",
            text: "zadanie",
          }).then((result) => {
            if (+taskData.cycleId > 0) {
              deleteCycle();
            } else {
              props.closeTaskPopUp();
            }
          });
        }
      }
    });
  };

  const addTaskIfCond8a2 = async (e) => {
    if (taskData.task_conn === "c") {
      var body = {
        id: taskData.clientId,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getPPClientId", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then(async (data) => {
          var body2 = {
            user: data[0].praw_pozew,
          };

          await fetch("https://apidevkppp.ftpeople.pl/getAllowedUser", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body2),
          })
            .then((response) => response.json())
            .then(async (data2) => {
              var allowed = data2[0];

              var date_added =
                new Date().getFullYear() +
                "-" +
                (new Date().getMonth() + 1) +
                "-" +
                new Date().getDate() +
                " " +
                new Date().getHours() +
                ":" +
                new Date().getMinutes();
              var date_start =
                new Date().getFullYear() +
                "-" +
                (new Date().getMonth() + 1) +
                "-" +
                new Date().getDate();
              var dateFinal = new Date();

              var newFinalDate = addDay3Months(new Date());
              if (newFinalDate.getDay() === 0) {
                newFinalDate = new Date(
                  newFinalDate.setDate(newFinalDate.getDate() + 1)
                );
              }
              if (newFinalDate.getDay() === 6) {
                newFinalDate = new Date(
                  newFinalDate.setDate(newFinalDate.getDate() + 2)
                );
              }

              var date_final = newFinalDate;

              while (
                (checkFree(date_final) ||
                  checkHoliday(data[0].praw_pozew, date_final)) &&
                (date_final.getDay() === 0 || date_final.getDay() === 6)
              ) {
                date_final = addDayOne(date_final);
              }

              dateFinal =
                date_final.getFullYear() +
                "-" +
                (date_final.getMonth() + 1) +
                "-" +
                date_final.getDate();

              var resp = userSend4;

              var body5 = {
                responsible: resp,
                start_date: date_start,
                final_date: dateFinal,
                bank: taskData.bank,
                sygn: taskData.sygn,
                client_name: taskData.client_name,
                task: "Weryfikacja czy sąd zarządził doręczenie pozwu stronie przeciwnej",
                date_added: date_added,
                user_added: props.user.name,
                status: "ZLECONE",
                court: taskData.court,
                type: "POZASĄDOWE",
                readed: "no",
                addRole: taskData.addRole,
                cycleId: "",
                clientId: taskData.task_conn === "c" ? taskData.clientId : "",
                task_conn: taskData.task_conn,
                team: taskData.team,
                note: "",
              };

              fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body5),
              })
                .then((response) => response.json())
                .then((data) => {})
                .catch((error) => {});
            });
        })
        .catch((error) => {});
    }

    MySwal.fire({
      title: "Czy chcesz dodać adresata do książki nadawczej?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowSendPost(true);
      } else if (result.isDenied) {
        if (checkTaskType(taskData.task)) {
          addTaskIfCond11();
        } else {
          MySwal.fire({
            icon: "success",
            title: "Wykonano",
            text: "zadanie",
          }).then((result) => {
            if (+taskData.cycleId > 0) {
              deleteCycle();
            } else {
              props.closeTaskPopUp();
            }
          });
        }
      }
    });
  };

  const addTaskIfCond9 = async (e) => {
    if (taskData.task_conn === "c") {
      var body = {
        status: "wygrana w I instancji - wpłynęła apelacja",
        status_note: "",
        id: taskData.clientId,
      };

      fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          return;
        })
        .catch((error) => {});
    }

    MySwal.fire({
      title: "Czy chcesz dodać adresata do książki nadawczej?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowSendPost(true);
      } else if (result.isDenied) {
        if (checkTaskType(taskData.task)) {
          addTaskIfCond11();
        } else {
          MySwal.fire({
            icon: "success",
            title: "Wykonano",
            text: "zadanie",
          }).then((result) => {
            if (+taskData.cycleId > 0) {
              deleteCycle();
            } else {
              props.closeTaskPopUp();
            }
          });
        }
      }
    });
  };

  const addTaskIfCond10 = async (e) => {
    if (taskData.task_conn === "c") {
      var model = [];

      model["przegrana w I instancji - wnieśliśmy apelację"] =
        "przegrana w I instancji - wnieśliśmy apelację";
      model["wygrana w I. instancji - wnieśliśmy apelację"] =
        "wygrana w I. instancji - wnieśliśmy apelację";
      model["wygrana w I. instancji - apelacja obustronna"] =
        "wygrana w I. instancji - apelacja obustronna";

      MySwal.fire({
        title: "Wybierz nowy status",
        input: "select",
        inputOptions: model,
        inputPlaceholder: "wybierz status",
        showCancelButton: true,
        cancelButtonText: "Anuluj",
        inputValidator: function (value) {
          return new Promise(function (resolve, reject) {
            if (value !== "") {
              resolve();
            } else {
              resolve("musisz wybrać status");
            }
          });
        },
      }).then(function (result) {
        if (result.isConfirmed) {
          var body = {
            status: result.value,
            status_note: "",
            id: taskData.clientId,
          };

          fetch("https://apidevkppp.ftpeople.pl/setClientStatus", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.text())
            .then((data) => {
              MySwal.fire({
                title: "Czy chcesz dodać adresata do książki nadawczej?",
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: "Tak",
                denyButtonText: `Nie`,
              }).then(async (result) => {
                if (result.isConfirmed) {
                  setShowSendPost(true);
                } else if (result.isDenied) {
                  if (checkTaskType(taskData.task)) {
                    addTaskIfCond11();
                  } else {
                    MySwal.fire({
                      icon: "success",
                      title: "Wykonano",
                      text: "zadanie",
                    }).then((result) => {
                      if (+taskData.cycleId > 0) {
                        deleteCycle();
                      } else {
                        props.closeTaskPopUp();
                      }
                    });
                  }
                }
              });
            })
            .catch((error) => {});
        } else if (result.isDenied || result.isDismissed) {
          if (checkTaskType(taskData.task)) {
            addTaskIfCond11();
          } else {
            MySwal.fire({
              title: "Czy chcesz dodać adresata do książki nadawczej?",
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: "Tak",
              denyButtonText: `Nie`,
            }).then(async (result) => {
              if (result.isConfirmed) {
                setShowSendPost(true);
              } else if (result.isDenied) {
                if (checkTaskType(taskData.task)) {
                  addTaskIfCond11();
                } else {
                  MySwal.fire({
                    icon: "success",
                    title: "Wykonano",
                    text: "zadanie",
                  }).then((result) => {
                    if (+taskData.cycleId > 0) {
                      deleteCycle();
                    } else {
                      props.closeTaskPopUp();
                    }
                  });
                }
              }
            });
          }
        }
      });
    } else {
      MySwal.fire({
        title: "Czy chcesz dodać adresata do książki nadawczej?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          setShowSendPost(true);
        } else if (result.isDenied) {
          if (checkTaskType(taskData.task)) {
            addTaskIfCond11();
          } else {
            MySwal.fire({
              icon: "success",
              title: "Wykonano",
              text: "zadanie",
            }).then((result) => {
              if (+taskData.cycleId > 0) {
                deleteCycle();
              } else {
                props.closeTaskPopUp();
              }
            });
          }
        }
      });
    }
  };

  const addTaskIfCond12 = async (e) => {
    var date_added =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes();
    var date_start =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    var dateFinal = new Date();

    var newFinalDate = addWeeksFour(new Date());
    if (newFinalDate.getDay() === 0) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 1));
    }
    if (newFinalDate.getDay() === 6) {
      newFinalDate = new Date(newFinalDate.setDate(newFinalDate.getDate() + 2));
    }

    var date_final = newFinalDate;

    while (
      (checkFree(date_final) || checkHoliday("Marta Kurzyk", date_final)) &&
      (date_final.getDay() === 0 || date_final.getDay() === 6)
    ) {
      date_final = addDayOne(date_final);
    }

    dateFinal =
      date_final.getFullYear() +
      "-" +
      (date_final.getMonth() + 1) +
      "-" +
      date_final.getDate();

    var resp =
      +props.team === 1
        ? usersSend6.filter((el) => +el.team === 1)[0].user
        : usersSend6.filter((el) => +el.team === 2)[0].user;

    var body5 = {
      responsible: resp,
      start_date: date_start,
      final_date: dateFinal,
      bank: taskData.bank,
      sygn: taskData.sygn,
      client_name: taskData.client_name,
      task: "Rozważ wysyłkę prezentu",
      date_added: date_added,
      user_added: props.user.name,
      status: "ZLECONE",
      court: taskData.court,
      type: "POZASĄDOWE",
      readed: "no",
      addRole: taskData.addRole,
      cycleId: "",
      clientId: taskData.task_conn === "c" ? taskData.clientId : "",
      task_conn: taskData.task_conn,
      team: taskData.team,
      note: "",
    };

    fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body5),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      title: "Czy chcesz dodać adresata do książki nadawczej?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowSendPost(true);
      } else if (result.isDenied) {
        if (checkTaskType(taskData.task)) {
          addTaskIfCond11();
        } else {
          MySwal.fire({
            icon: "success",
            title: "Wykonano",
            text: "zadanie",
          }).then((result) => {
            if (+taskData.cycleId > 0) {
              deleteCycle();
            } else {
              props.closeTaskPopUp();
            }
          });
        }
      }
    });
  };

  const addTaskIfCond14 = async (e) => {
    var model = [];

    props.lawyersData
      .filter((el) => el.team.includes(props.team))
      .map((element) => {
        model[element.name] = element.name;
      });

    MySwal.fire({
      title: "Kto ma sprawdzić potrącenie?",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(function (result) {
      if (result.isConfirmed) {
        var resp = result.value;

        var date_added =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate() +
          " " +
          new Date().getHours() +
          ":" +
          new Date().getMinutes();
        var date_start =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate();
        var dateFinal = new Date();

        var newFinalDate = addDayOne(new Date());
        if (newFinalDate.getDay() === 0) {
          newFinalDate = new Date(
            newFinalDate.setDate(newFinalDate.getDate() + 1)
          );
        }
        if (newFinalDate.getDay() === 6) {
          newFinalDate = new Date(
            newFinalDate.setDate(newFinalDate.getDate() + 2)
          );
        }

        var date_final = newFinalDate;

        while (
          (checkFree(date_final) || checkHoliday(resp, date_final)) &&
          (date_final.getDay() === 0 || date_final.getDay() === 6)
        ) {
          date_final = addDayOne(date_final);
        }

        dateFinal =
          date_final.getFullYear() +
          "-" +
          (date_final.getMonth() + 1) +
          "-" +
          date_final.getDate();

        var body5 = {
          responsible: resp,
          start_date: date_start,
          final_date: dateFinal,
          bank: taskData.bank,
          sygn: taskData.sygn,
          client_name: taskData.client_name,
          task: "Sprawdzenie cofnięcia pozwu",
          date_added: date_added,
          user_added: props.user.name,
          status: "ZLECONE",
          court: taskData.court,
          type: "POZASĄDOWE",
          readed: "no",
          addRole: taskData.addRole,
          cycleId: "",
          clientId: taskData.task_conn === "c" ? taskData.clientId : "",
          task_conn: taskData.task_conn,
          team: taskData.team,
          note: "",
        };

        fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body5),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        var bodyX = {
          id: taskData.clientId,
          date: "TAK",
        };

        fetch("https://apidevkppp.ftpeople.pl/updateCofCzP", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(bodyX),
        })
          .then((response) => response.text())
          .then((responseJson) => {});

        MySwal.fire({
          title: "Czy chcesz dodać adresata do książki nadawczej?",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "Tak",
          denyButtonText: `Nie`,
        }).then(async (result) => {
          if (result.isConfirmed) {
            setShowSendPost(true);
          } else if (result.isDenied) {
            if (checkTaskType(taskData.task)) {
              addTaskIfCond11();
            } else {
              MySwal.fire({
                icon: "success",
                title: "Wykonano",
                text: "zadanie",
              }).then((result) => {
                if (+taskData.cycleId > 0) {
                  deleteCycle();
                } else {
                  props.closeTaskPopUp();
                }
              });
            }
          }
        });
      } else {
      }
    });
  };

  const addTaskIfCond11 = async (e) => {
    MySwal.fire({
      title: "Czy chcesz teraz dodać plik z pismem?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        handleShowSendFile();
      } else {
        if (
          client.pel_sub !== undefined &&
          client.pel_sub !== null &&
          client.pel_sub !== ""
        ) {
          MySwal.fire({
            icon: "success",
            title: "Wykonano",
            text: "zadanie",
          }).then((result) => {
            if (+taskData.cycleId > 0) {
              deleteCycle();
            } else {
              props.closeTaskPopUp();
            }
          });
        } else {
          MySwal.fire({
            title: "Czy chcesz dodać pełnomocnika substytucyjnego?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Tak",
            denyButtonText: `Nie`,
          }).then(async (result) => {
            if (result.isConfirmed) {
              setShowEditPelnSub(true);
            } else if (result.isDenied) {
              MySwal.fire({
                icon: "success",
                title: "Wykonano",
                text: "zadanie",
              }).then((result) => {
                if (+taskData.cycleId > 0) {
                  deleteCycle();
                } else {
                  props.closeTaskPopUp();
                }
              });
            }
          });
        }
      }
    });
  };

  const saveResponsibleUser = async () => {
    if (!checkFree(taskData.final_date)) {
      if (!checkHoliday(responsible, taskData.final_date)) {
        if (responsible.length > 0) {
          var body = {
            id: props.taskID,
            lawyer: responsible,
          };

          var bodyXX = {
            new: JSON.stringify(body),
            old: JSON.stringify(taskData),
            user: props.user.name,
            taskId: taskData.id,
          };

          fetch("https://apidevkppp.ftpeople.pl/addTaskHistory", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(bodyXX),
          })
            .then((response) => response.text())
            .then((data) => {});

          await fetch("https://apidevkppp.ftpeople.pl/fillLawyerTask", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then((data) => {})
            .catch((error) => {});

          MySwal.fire({
            icon: "success",
            title: "Przypisano",
            text: "użytkownika",
          }).then((result) => {
            props.closeTaskPopUp();
          });
        } else {
          MySwal.fire({
            icon: "error",
            title: "Błąd",
            text: "Wypełnij wymagane pola formularza",
          });
        }
      } else {
        MySwal.fire({
          title:
            "Osoba, której chcesz przypisać zadanie jest w tym czasie na urlopie. Czy nadal chcesz jej przypisać zadanie?",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "Tak",
          denyButtonText: `Nie`,
        }).then(async (result) => {
          if (result.isConfirmed) {
            if (responsible.length > 0) {
              var body = {
                id: props.taskID,
                lawyer: responsible,
              };

              await fetch("https://apidevkppp.ftpeople.pl/fillLawyerTask", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body),
              })
                .then((response) => response.json())
                .then((data) => {})
                .catch((error) => {});

              MySwal.fire({
                icon: "success",
                title: "Przypisano",
                text: "użytkownika",
              }).then((result) => {
                props.closeTaskPopUp();
              });
            } else {
              MySwal.fire({
                icon: "error",
                title: "Błąd",
                text: "Wypełnij wymagane pola formularza",
              });
            }
          } else if (result.isDenied) {
            setLoading(false);
          }
        });
      }
    } else {
      MySwal.fire({
        title:
          "W dniu wykonania zadania przypada dzień wolny. Czy nadal chcesz dodać zadanie?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (responsible.length > 0) {
            var body = {
              id: props.taskID,
              lawyer: responsible,
            };

            await fetch("https://apidevkppp.ftpeople.pl/fillLawyerTask", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.json())
              .then((data) => {})
              .catch((error) => {});

            MySwal.fire({
              icon: "success",
              title: "Przypisano",
              text: "użytkownika",
            }).then((result) => {
              props.closeTaskPopUp();
            });
          } else {
            MySwal.fire({
              icon: "error",
              title: "Błąd",
              text: "Wypełnij wymagane pola formularza",
            });
          }
        } else if (result.isDenied) {
          setLoading(false);
        }
      });
    }
  };

  const deleteTask = async (e) => {
    MySwal.fire({
      title: "Czy na pewno chcesz usunąć zadanie?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteTaskAccept();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteTaskAccept = async () => {
    var body = {
      id: props.taskID,
      user: props.user.name !== undefined ? props.user.name : props.uData.name,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire("Usunięto", "zadanie", "success").then((result) => {
      props.closeTaskPopUp();
      props.closeTaskPopUp();
    });
  };

  const showEditMode = (e) => {
    if (openEdit) {
      setOpenEdit(false);
      getData();
    } else {
      setOpenEdit(true);
    }
  };

  const handleResponsibleChange = (e) => {
    setResponsible(e.target.value);
  };

  const showHistory = (e) => {
    if (openHistory) {
      setOpenHistory(false);
      getData();
    } else {
      setOpenHistory(true);
    }
  };

  const getClientsArray = () => {
    var clients = [];
    var newArray = taskData.client_name.split(",");
    newArray.map((el) => {
      clients.push({ id: Math.random() * 100, name: el });
    });

    return clients;
  };

  const showNotePopUp = (e) => {
    if (notePopUp) {
      setNotePopUp(false);
      getData();
    } else {
      setNotePopUp(true);
    }
  };

  const fetchBufferListAll = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBuforListPostBookAll", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.przesylka.map((el) => {
          arr.push(el.attributes.numerNadania);
        });

        setBufPost(arr);
        fetchTasksData();
      })
      .catch((error) => {
        fetchTasksData();
      });
  };

  const fetchTasksData = async (id) => {
    var body = {
      id: props.taskID,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        setTaskData(data[0]);

        if (data[0].task_conn === "c") {
          var body2 = {
            id: data[0].clientId,
          };

          var arr = [];
          var post = data[0].postNumber ? data[0].postNumber.split("\n") : [];

          post.map((el, index) => {
            var g = data[0].postGuid ? data[0].postGuid.split("\n")[index] : "";
            var ele = el.split(" - ");
            var rec = {
              num: ele[0],
              recip: ele[1],
              guid: g,
            };

            arr.push(rec);
          });

          setPostData(arr);

          await fetch("https://apidevkppp.ftpeople.pl/getClientsId", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body2),
          })
            .then((response) => response.json())
            .then((data2) => {
              setClient(data2[0]);
              fetchTasksClientData(data[0].clientId);
            })
            .catch((error) => {});
        } else {
          var arr = [];
          var post = data[0].postNumber ? data[0].postNumber.split("\n") : [];

          post.map((el, index) => {
            var g = data[0].postGuid ? data[0].postGuid.split("\n")[index] : "";
            var ele = el.split(" - ");
            var rec = {
              num: ele[0],
              recip: ele[1],
              guid: g,
            };

            arr.push(rec);
          });

          setPostData(arr);
        }
      })
      .catch((error) => {});
  };

  const fetchTasksClientData = async (id) => {
    var body = {
      clientId: id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksClientId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTasksForClient(data);
      })
      .catch((error) => {});
  };

  const fetchFiles = async (id) => {
    var body = {
      taskId: props.taskID,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFilesTaskId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFilesData(data);
        fetchHolidays();
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchBufferListAll();
    fetchFiles();
  };

  useEffect(() => {
    getData();
  }, []);

  const deleteFile = async (e) => {
    var body = {
      id: e.target.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteFile", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: "plik",
    }).then((result) => {
      if (+taskData.clientId > 0) {
        props.logClientAction("Usunięto plik", taskData.clientId);
      }
      getData();
    });
  };

  const changeFileNameK = async (e) => {
    MySwal.fire({
      title: "Wprowadź nazwę pliku",
      input: "text",
      inputPlaceholder: "Nazwa pliku",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wprowadzić nazwę pliku");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var body4 = {
          id: e.target.value,
          name: result.value,
        };

        await fetch("https://apidevkppp.ftpeople.pl/setFileName", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body4),
        })
          .then((response) => response.json())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const download = async (url, filename) => {
    const data = await fetch(url);
    const blob = await data.blob();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.setAttribute("href", objectUrl);
    link.setAttribute("download", filename);
    link.style.display = "none";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const downloadFile = (e) => {
    var file = filesData.filter((el) => el.id === +e.target.value)[0];
    download(file.link, file.name);
  };

  const files = (
    <>
      <div style={{ marginBottom: "3vh" }}>
        {filesData.filter(
          (el) => el.type === "task" && +el.taskId === +props.taskID
        ).length > 0 ? (
          <>
            <p style={{ textTransform: "uppercase", fontSize: "2vw" }}>
              dokumenty
            </p>
            <table
              style={{ width: "80%" }}
              id="detailClientTable"
              className="clients_table"
            >
              <tr>
                <th>Nazwa pliku</th>
                <th>Użytkownik</th>
                <th>Data</th>
                <th>Pokaż</th>
                <th></th>
              </tr>
              {filesData
                .filter(
                  (el) => el.type === "task" && +el.taskId === +props.taskID
                )
                .map((file) => (
                  <>
                    <tr>
                      <td
                        style={{
                          width: "30%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        {file.name}
                      </td>
                      <td
                        style={{
                          width: "20%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        {file.user}
                      </td>
                      <td
                        style={{
                          width: "20%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        {new Date(file.date).getFullYear() +
                          "-" +
                          (new Date(file.date).getMonth() + 1 < 10
                            ? "0" + (new Date(file.date).getMonth() + 1)
                            : new Date(file.date).getMonth() + 1) +
                          "-" +
                          (new Date(file.date).getDate() < 10
                            ? "0" + new Date(file.date).getDate()
                            : new Date(file.date).getDate())}{" "}
                        {(new Date(file.date).getHours() < 10
                          ? "0" + new Date(file.date).getHours()
                          : new Date(file.date).getHours()) +
                          ":" +
                          (new Date(file.date).getMinutes() < 10
                            ? "0" + new Date(file.date).getMinutes()
                            : new Date(file.date).getMinutes())}
                      </td>
                      <td
                        style={{
                          width: "10%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        <button
                          className="refreshButton"
                          value={file.id}
                          onClick={downloadFile}
                        >
                          pokaż
                        </button>
                      </td>
                      <td
                        style={{
                          width: "20%",
                          padding: "5px 20px",
                          height: "3vh",
                        }}
                      >
                        <button
                          className="refreshButton"
                          value={file.id}
                          onClick={deleteFile}
                        >
                          usuń
                        </button>
                        <button
                          style={{ marginLeft: "10px" }}
                          className="refreshButton"
                          value={file.id}
                          onClick={changeFileNameK}
                        >
                          zmień nazwę
                        </button>
                      </td>
                    </tr>
                  </>
                ))}
            </table>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );

  const showAddCLientP = () => {
    setShowAddClientConn(true);
  };

  const closeAddCLient = () => {
    setShowAddClientConn(false);
    getData();
  };

  const deleteConn = () => {
    MySwal.fire({
      title: "Czy na pewno chcesz powiązanie?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteConnAccept();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteConnAccept = async () => {
    var body = {
      id: taskData.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteClientTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire("Usunięto", "powiązanie", "success").then((result) => {
      getData();
    });
  };

  const handleShowSendFile = (e) => {
    setShowAddFile(true);
  };

  const closeSendFile = (e) => {
    setShowAddFile(false);

    MySwal.fire({
      title: "Czy chcesz dodać pełnomocnika substytucyjnego?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowEditPelnSub(true);
      } else if (result.isDenied) {
        MySwal.fire({
          icon: "success",
          title: "Wykonano",
          text: "zadanie",
        }).then((result) => {
          if (+taskData.cycleId > 0) {
            deleteCycle();
          } else {
            props.closeTaskPopUp();
          }
        });
      }
    });
  };

  const checkHoliday = (responsible, date) => {
    var final_date = new Date(date);
    var blocks = holidays.filter((el) => el.user === responsible);
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (new Date(el.date_from) >= final_date &&
            new Date(el.date_from) <= final_date) ||
          (final_date >= new Date(el.date_from) &&
            final_date <= new Date(el.date_to))
        ) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const fetchPrintLabel = async (e) => {
    var body = {
      guid: e.currentTarget.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getPostBookByGuid", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        handleOpenPdfInNewTab(data.printResult[0].print);
      })
      .catch((error) => {});
  };

  const fetchPrintLabelMobile = async (e) => {
    var body = {
      guid: e.currentTarget.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getPostBookByGuid", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        handleDownloadPdfInNewTab(data.printResult[0].print);
      })
      .catch((error) => {});
  };

  const handleDownloadPdfInNewTab = (base64Pdf) => {
    try {
      var pdf = `data:application/pdf;base64,${base64Pdf}`;

      const pdfLink = `${pdf.file}`;
      const anchorElement = document.createElement("a");
      const fileName = `raport.pdf`;
      anchorElement.href = pdfLink;
      anchorElement.download = fileName;
      anchorElement.click();
    } catch (error) {
      console.error("Error opening PDF in new tab:", error);
      // } finally {
      //   if (w) w.document.close();
      // }
    }
  };

  const handleOpenPdfInNewTab = (base64Pdf) => {
    try {
      var pdfData = `data:application/pdf;base64,${base64Pdf}`;

      var w = window.open("");

      if (w) {
        w.document.write(
          `<embed width="100%" height="100%" src="${pdfData}" type="application/pdf" />`
        );
      } else {
        throw new Error("Failed to open a new tab.");
      }
    } catch (error) {
      console.error("Error opening PDF in new tab:", error);
    }
  };

  return (
    <>
      {showClientReport ? (
        <ClientPopUp
          close={closeClientPopUp}
          paymentsData={props.paymentsData}
          paymentsSheetData={props.paymentsSheetData}
          transactionsSheetData={props.transactionsSheetData}
          transactionsASheetData={props.transactionsNaSheetData}
          transactionsData={props.transactionsData}
          paymentsArchiveSheetData={props.paymentsArchiveSheetData}
          id={clientsReportValue}
          team={props.team}
          refreshData={props.refreshData}
          user={props.user.name}
          clientsData={client}
          clientsSheetData={props.clientsSheetData}
          userRole={props.user.role}
          userMail={props.user.mail}
          userPhone={props.user.Phone}
          substitutesData={props.substitutesData}
          tasksData={props.tasksData}
          hearingsData={props.hearingsData}
          hearingsSheetData={props.hearingsSheetData}
          tasksSheetData={props.tasksSheetData}
          lawyersData={props.lawyersData}
          courtsData={props.courtsData}
          banksData={props.banksData}
          users={props.usersData}
          resultsData={props.resultsData}
          tasksTypesData={props.tasksTypesData}
          checkPermissions={props.checkPermissions}
          hearingsTeam2Data={props.hearingsTeam2Data}
          hearingsTeam2SheetData={props.hearingsTeam2SheetData}
          tasksTeam2Data={props.tasksTeam2Data}
          tasksTeam2SheetData={props.tasksTeam2SheetData}
          archTasksTeam2={props.archTasksTeam2}
          archDateTeam2={props.archDateTeam2}
          archDate={props.archDate}
          clientsSygnSheetData={props.clientsSygnSheetData}
          clientsContactData={props.clientsContactData}
          clientsContactSheetData={props.clientsContactSheetData}
          logClientAction={props.logClientAction}
          clientsLogsData={props.clientsLogsData}
          clientsQuestData={props.clientsQuestData}
          clientsQuestSheetData={props.clientsQuestSheetData}
          tabIndex={0}
          uData={props.user}
          clientsFullData={clients}
          filesData={props.filesData}
        />
      ) : (
        ""
      )}
      {showAdditionalWezw ? (
        <AdditionalWezw
          clientId={taskData.clientId}
          close={closeAdditionalWezw}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
        />
      ) : (
        ""
      )}
      {showChecklist ? (
        <LawsuitCheckList
          close={closeCheckList}
          logClientAction={props.logClientAction}
          client={client}
          user={props.user}
          users={props.usersData}
          finalChecker={
            tasksForClient.filter(
              (el) => el.task === "Nadanie pozwu" && el.status === "ZLECONE"
            ).length > 0
              ? tasksForClient.filter(
                  (el) => el.task === "Nadanie pozwu" && el.status === "ZLECONE"
                )[0].responsible
              : "a.pludowska@kppp.pl"
          }
        />
      ) : (
        ""
      )}
      {showAddClientConn ? (
        <AddClientConn
          close={closeAddCLient}
          id={taskData.id}
          team={props.team}
          place="task"
          user={props.user}
        />
      ) : (
        ""
      )}
      {showAddFile ? (
        <AddFile
          close={closeSendFile}
          logClientAction={props.logClientAction}
          id={taskData.clientId}
          taskId={taskData.id}
          users={props.users}
          userRole={props.userRole}
          lawyersData={props.lawyersData}
          tabIndex={0}
          team={props.team}
          user={props.user.name}
          place={"task"}
          client={client}
        />
      ) : (
        ""
      )}
      {showAdditionalPozw ? (
        <AdditionalPozw
          clientId={taskData.clientId}
          close={closeAdditionalPozw}
          refreshData={props.refreshData}
          logClientAction={props.logClientAction}
          clientsData={props.clientsData}
          courtsData={props.courtsData}
          uName={props.user.name}
        />
      ) : (
        ""
      )}
      {openEdit ? (
        <AddTask
          tasksSheetData={props.tasksSheetData}
          usersData={props.usersData}
          refreshData={props.refreshData}
          user={props.user}
          tasksTypesData={props.tasksTypesData}
          banksData={props.banksData}
          handleOptionChangeClose={props.handleOptionChangeClose}
          checkPermissions={props.checkPermissions}
          close={showEditMode}
          taskData={taskData}
          clients={getClientsArray()}
          client={client}
          mode={"edit"}
          courtsData={props.courtsData}
          team={props.team}
          usersData={props.usersData}
          tasksTeam2Data={props.tasksTeam2Data}
          hearingsTeam2Data={props.hearingsTeam2Data}
          hearingsTeam2SheetData={props.hearingsTeam2SheetData}
          tasksTeam2SheetData={props.tasksTeam2SheetData}
          archDateTeam2={props.archDateTeam2}
          archTasksTeam2={props.archTasksTeam2}
          archTasks={props.archTasks}
        />
      ) : (
        ""
      )}
      {notePopUp ? (
        <NotePopUp
          content={taskData.note_task}
          type={"note"}
          closePopUp={showNotePopUp}
          checkPermissions={props.checkPermissions}
        />
      ) : (
        ""
      )}
      {showEditPelnSub ? (
        <EditPelnSub
          close={closeEditPelnSub}
          refreshData={props.refreshData}
          clientsData={client}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={client}
          userName={props.user}
          mode="task"
        />
      ) : (
        ""
      )}
      {openHistory ? (
        <HistoryPopUp
          clientName={taskData.client_name}
          tasksData={props.team === 1 ? props.tasksData : props.tasksTeam2Data}
          hearingsData={props.hearingsData}
          close={showHistory}
          checkPermissions={props.checkPermissions}
          team={props.team}
          tasksTeam2Data={props.tasksTeam2Data}
          hearingsTeam2Data={props.hearingsTeam2Data}
          hearingsTeam2SheetData={props.hearingsTeam2SheetData}
          tasksTeam2SheetData={props.tasksTeam2SheetData}
          archDateTeam2={props.archDateTeam2}
          archTasksTeam2={props.archTasksTeam2}
          archTasks={props.archTasks}
          filesData={filesData}
          user={props.user}
          lawyersData={props.lawyersData}
          tasksTypesData={props.tasksTypesData}
          usersData={props.usersData}
          logClientAction={props.logClientAction}
          substitutesData={props.substitutesData}
        />
      ) : (
        ""
      )}
      {showLawsuitChecklist ? (
        <LawsuitCheckList
          close={() => {
            setShowLawsuitChecklist(false);
            getData();
          }}
          logClientAction={props.logClientAction}
          client={client}
          user={props.user}
          users={props.users}
          finalChecker={
            tasksForClient.filter(
              (el) => el.task === "Nadanie pozwu" && el.status === "ZLECONE"
            ).length > 0
              ? tasksForClient.filter(
                  (el) => el.task === "Nadanie pozwu" && el.status === "ZLECONE"
                )[0].responsible
              : "Aleksandra Płudowska"
          }
        />
      ) : (
        ""
      )}
      {showLawsuitChecklistView ? (
        <LawsuitCheckListView
          close={() => {
            setShowLawsuitChecklistView(false);
            getData();
          }}
          logClientAction={props.logClientAction}
          client={client}
          user={props.user}
          users={props.users}
          finalChecker={
            tasksForClient.filter(
              (el) => el.task === "Nadanie pozwu" && el.status === "ZLECONE"
            ).length > 0
              ? tasksForClient.filter(
                  (el) => el.task === "Nadanie pozwu" && el.status === "ZLECONE"
                )[0].responsible
              : "a.pludowska@kppp.pl"
          }
        />
      ) : (
        ""
      )}
      {showEdit ? (
        <>
          <SendPostTask
            close={() => {
              setShowEdit(false);
              getData();
            }}
            mode={"edit"}
            numNad={numNad}
            guid={guid}
            task={taskData}
            client={client}
          />
        </>
      ) : (
        ""
      )}
      {showSendPost ? (
        <>
          <SendPostTask close={closeSendPost} client={client} task={taskData} />
        </>
      ) : (
        ""
      )}
      {packageInfo ? (
        <>
          <CheckPackage
            close={() => setPackageInfo(false)}
            num={packageInfoNum}
          />
        </>
      ) : (
        ""
      )}
      {openEdit ||
      openHistory ||
      showClientReport ||
      showLawsuitChecklist ||
      showLawsuitChecklistView ||
      showChecklist ? (
        ""
      ) : (
        <>
          <div className="mainContainerTaskPopUp">
            {loading ? (
              <Loading id="popUpLoading" />
            ) : (
              <>
                <div className="closeBox">
                  <button
                    className="closeClientButton"
                    onClick={props.closeTaskPopUp}
                  >
                    X
                  </button>
                </div>
                <div className="hearingTitle">
                  Zadanie: <span className="highlight">{taskData.task}</span>
                </div>
                <div className="editButtonBox">
                  {true ? (
                    <>
                      {(props.user.name === taskData.responsible &&
                        props.checkPermissions("zadanieEdycja") &&
                        taskData.task !== "Apelacja") ||
                      (props.user.role === "admin" &&
                        props.checkPermissions("zadanieEdycja") &&
                        taskData.task !== "Apelacja") ||
                      (taskData.task === "Apelacja" &&
                        props.user.editApel === "1") ? (
                        <button className="acceptButton" onClick={showEditMode}>
                          EDYTUJ
                        </button>
                      ) : (
                        ""
                      )}
                      {(props.user.name === taskData.responsible &&
                        props.checkPermissions("zadanieUsun") &&
                        (taskData.task === "Apelacja"
                          ? props.user.editApel === "1"
                          : true)) ||
                      (props.checkPermissions("zadanieUsun") &&
                        props.user.role === "admin" &&
                        (taskData.task === "Apelacja"
                          ? props.user.editApel === "1"
                          : true)) ? (
                        <button className="acceptButton" onClick={deleteTask}>
                          Usuń
                        </button>
                      ) : (
                        ""
                      )}
                      {props.checkPermissions("zadanieHistoria") ? (
                        <button className="acceptButton" onClick={showHistory}>
                          HISTORIA
                        </button>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
                <div style={{ display: "block" }} className="editButtonBox">
                  {taskData.task_conn === "c" ? (
                    <>
                      <div style={{ marginBottom: "15px" }}>
                        <span
                          style={{ color: "black" }}
                          className="highlight_green"
                        >
                          SPRAWA KLIENTA: {client.petitioner}
                        </span>
                      </div>
                      <div style={{ display: "flex", gap: "20px" }}>
                        <button
                          style={{ fontSize: "0.7vw" }}
                          className="acceptButton"
                          onClick={showClientPopUp}
                        >
                          ZOBACZ
                        </button>
                        <button
                          style={{ fontSize: "0.7vw" }}
                          className="acceptButton"
                          onClick={deleteConn}
                        >
                          USUŃ POWIĄZANIE
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={{ marginBottom: "15px" }}>
                        <span
                          style={{ color: "black" }}
                          className="highlight_green"
                        >
                          ROZPRAWA NIEPOWIĄZANA ZE SPRAWĄ
                        </span>
                      </div>
                      <button
                        style={{ fontSize: "0.7vw" }}
                        className="acceptButton"
                        onClick={showAddCLientP}
                      >
                        DODAJ POWIĄZANIE
                      </button>
                    </>
                  )}
                </div>
                <div className="hearingData">
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">DATA ROZPOCZĘCIA</div>
                    <div className="hearingBoxContent">
                      {taskData.start_date}
                    </div>
                  </div>
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">TERMIN WYKONANIA</div>
                    <div className="hearingBoxContent">
                      {taskData.final_date}
                    </div>
                  </div>
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">
                      IMIĘ I NAZWISKO KLIENTA
                    </div>
                    <div className="hearingBoxContent">
                      {taskData.client_name}
                    </div>
                  </div>
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">BANK</div>
                    <div className="hearingBoxContent">{taskData.bank}</div>
                  </div>
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">SYGNATURA AKT</div>
                    <div className="hearingBoxContent">{taskData.sygn}</div>
                  </div>
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">SĄD</div>
                    <div className="hearingBoxContent">
                      {taskData.court === "" || taskData.court === undefined
                        ? "brak danych"
                        : taskData.court}
                    </div>
                  </div>
                  {taskData.responsible === "" ? (
                    ""
                  ) : (
                    <div className="hearingBox">
                      <div className="hearingBoxTitle">
                        OSOBA ODPOWIEDZIALNA
                      </div>
                      <div className="hearingBoxContent">
                        {taskData.responsible}
                      </div>
                    </div>
                  )}
                  <div className="hearingBox">
                    <div className="hearingBoxTitle">STATUS</div>
                    <div className="hearingBoxContent">{taskData.status}</div>
                  </div>
                  {taskData.postNumber ? (
                    <div className="hearingBox">
                      <div className="hearingBoxTitle">NUMER NADANIA</div>
                      <div
                        className="hearingBoxContent"
                        style={{
                          justifyContent: "left",
                          overflow: "scroll",
                          height: "16vh",
                        }}
                      >
                        {postData.map((el) => (
                          <>
                            {el.num !== "" ? (
                              <>
                                <div style={{ width: "100%" }}>
                                  <p>{el.num}</p>
                                  <p>
                                    {el.recip}
                                    {bufPost.filter((e) => e === el.num)
                                      .length > 0 ? (
                                      <>
                                        <button
                                          style={{
                                            marginLeft: "10px",
                                            width: "10%",
                                            backgroundColor: "transparent",
                                            color: "#a5bea4",
                                            border: "none",
                                            fontSize: "1vw",
                                          }}
                                          id="clientsButton"
                                          className="paymentMenuButton"
                                          value={el.num}
                                          onClick={showEditModePost}
                                        >
                                          <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button
                                          style={{
                                            width: "10%",
                                            backgroundColor: "transparent",
                                            color: "#a5bea4",
                                            border: "none",
                                            fontSize: "1vw",
                                            textAlign: "center",
                                          }}
                                          id="clientsButton"
                                          className="paymentMenuButton"
                                          value={el.num}
                                          onClick={showCheck}
                                        >
                                          <FontAwesomeIcon icon={faEye} />
                                        </button>
                                      </>
                                    ) : (
                                      <>
                                        <button
                                          style={{
                                            width: "10%",
                                            backgroundColor: "transparent",
                                            color: "#a5bea4",
                                            border: "none",
                                            fontSize: "1vw",
                                            textAlign: "center",
                                          }}
                                          id="clientsButton"
                                          className="paymentMenuButton"
                                          value={el.num}
                                          onClick={showCheck}
                                        >
                                          <FontAwesomeIcon icon={faEye} />
                                        </button>
                                        <div id="asd2">
                                          <button
                                            style={{
                                              width: "10%",
                                              backgroundColor: "transparent",
                                              color: "#a5bea4",
                                              border: "none",

                                              textAlign: "center",
                                            }}
                                            id="asd5"
                                            className="paymentMenuButton"
                                            value={el.guid}
                                            onClick={fetchPrintLabel}
                                          >
                                            <FontAwesomeIcon icon={faPrint} />
                                          </button>
                                        </div>
                                        <div id="asd3">
                                          <button
                                            style={{
                                              width: "10%",
                                              backgroundColor: "transparent",
                                              color: "#a5bea4",
                                              border: "none",

                                              textAlign: "center",
                                            }}
                                            id="asd5"
                                            className="paymentMenuButton"
                                            value={el.guid}
                                            onClick={fetchPrintLabelMobile}
                                          >
                                            <FontAwesomeIcon icon={faPrint} />
                                          </button>
                                        </div>
                                      </>
                                    )}
                                  </p>
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </>
                        ))}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {taskData.note_task === undefined ||
                  taskData.note_task === "" ||
                  taskData.note_task === "undefined" ? (
                    ""
                  ) : (
                    <div className="hearingBox">
                      <div className="hearingBoxTitle">NOTATKA</div>
                      <div className="hearingBoxContent">
                        <div className="noteShort">
                          {taskData.note_task === "undefined"
                            ? ""
                            : taskData.note_task.substring(0, 100)}
                          ...
                        </div>
                        <button
                          id="boxButton"
                          className="acceptButton"
                          value="note"
                          onClick={showNotePopUp}
                        >
                          POKAŻ CAŁĄ TREŚĆ
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                {files}
                {taskData.task === "Sporządzenie pozwu" ||
                taskData.task === "Sprawdzenie pozwu" ||
                taskData.task === "Wysyłka pozwu" ||
                taskData.task === "Nadanie pozwu" ||
                taskData.task ===
                  "Sprawdzenie pozwu do nadania po poprawkach + weryfikacja wydruku" ? (
                  <div className="hearingFunctionalitesBox">
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <p>CHECKLISTA</p>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="sec_wn"
                        onClick={handleShowAddChecklist}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button
                        style={{
                          marginLeft: "10px",
                          width: "10%",
                          backgroundColor: "transparent",
                          color: "#a5bea4",
                          border: "none",
                          fontSize: "1vw",
                        }}
                        id="clientsButton"
                        className="paymentMenuButton"
                        value="sec_wn"
                        onClick={handleShowAddChecklistView}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="hearingFunctionalitesBox">
                  {(props.user.name === taskData.responsible ||
                    props.user.role === "admin") &&
                  props.checkPermissions("zadanieWykonanie") ? (
                    taskData.status === "ZLECONE" &&
                    taskData.responsible !== "" ? (
                      <button
                        className="functionalitesButton"
                        value="fillHearing"
                        onClick={saveAcceptTask}
                      >
                        OZNACZ JAKO WYKONANE
                      </button>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  {taskData.status === "WYKONANE" && true ? (
                    <button
                      style={{ width: "300px" }}
                      className="functionalitesButton"
                      value="fillHearing"
                      onClick={() => {
                        setShowSendPost(true);
                        setShowSendPostButton(true);
                      }}
                    >
                      DODAJ ADRESATA DO KSIĄŻKI NADAWCZEJ
                    </button>
                  ) : (
                    ""
                  )}
                  {props.user.role === "admin" ||
                  props.checkPermissions("zadaniePrzypisanieUsera") ? (
                    taskData.responsible === "" ? (
                      <button
                        className="functionalitesButton"
                        value="fillHearing"
                        onClick={setFill}
                      >
                        PRZYPISZ PRACOWNIKA
                      </button>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>
                {fillResponsible ? (
                  <>
                    <div className="inputContainer">
                      <div className="inputBox">
                        <div className="inputCol_3">
                          <label>
                            Osoba odpowiedzialna{" "}
                            <span className="requiredStar">*</span>
                          </label>
                          <select
                            type="text"
                            id="court"
                            name="court"
                            value={responsible}
                            onChange={handleResponsibleChange}
                          >
                            {responsible === "" ? (
                              <option key="0" value="no">
                                Wybierz z listy...
                              </option>
                            ) : (
                              ""
                            )}
                            {props.usersData.map((el) => (
                              <option key={el.name} value={el.name}>
                                {el.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="acceptButtonContainerDate">
                        <button
                          className="acceptButton"
                          onClick={saveResponsibleUser}
                        >
                          ZAPISZ DANE
                        </button>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
                <div style={{ padding: "20px", zIndex: "0 " }}>
                  To zadanie zostało przełozone:{" "}
                  {taskData.count_rescheduling === undefined ||
                  taskData.count_rescheduling === null
                    ? "0"
                    : taskData.count_rescheduling}{" "}
                  {(taskData.count_rescheduling === undefined ||
                  taskData.count_rescheduling === null
                    ? "0"
                    : taskData.count_rescheduling) === 1
                    ? "raz."
                    : "razy."}
                  {taskData.realDoDate
                    ? " Rzeczywista data wykonania zadania: " +
                      taskData.realDoDate
                    : ""}
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default TaskPopUp;
